var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankSwed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 80,
    viewBox: "0 0 260 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2690_4771)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.433 40C226.433 43.8436 225.294 47.6008 223.158 50.7966C221.023 53.9924 217.988 56.4832 214.437 57.9541C210.886 59.4249 206.978 59.8098 203.209 59.0599C199.439 58.3101 195.976 56.4592 193.259 53.7414C190.541 51.0236 188.69 47.561 187.94 43.7913C187.19 40.0216 187.575 36.1142 189.046 32.5632C190.517 29.0122 193.008 25.9771 196.203 23.8418C199.399 21.7064 203.156 20.5667 207 20.5667C209.552 20.5667 212.079 21.0693 214.437 22.0459C216.795 23.0226 218.937 24.454 220.741 26.2586C222.546 28.0631 223.977 30.2054 224.954 32.5632C225.931 34.9209 226.433 37.448 226.433 40Z",
    fill: "url(#paint0_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 18.9167C202.83 18.9167 198.754 20.1532 195.287 22.4698C191.82 24.7865 189.117 28.0793 187.522 31.9318C185.926 35.7842 185.508 40.0234 186.322 44.1132C187.135 48.2029 189.143 51.9596 192.092 54.9082C195.04 57.8567 198.797 59.8647 202.887 60.6782C206.977 61.4917 211.216 61.0742 215.068 59.4785C218.921 57.8827 222.214 55.1804 224.53 51.7133C226.847 48.2461 228.083 44.1699 228.083 40C228.083 34.4084 225.862 29.0457 221.908 25.0918C217.954 21.1379 212.592 18.9167 207 18.9167ZM207 60.1667C203.011 60.1667 199.112 58.9839 195.796 56.768C192.48 54.552 189.895 51.4024 188.368 47.7175C186.842 44.0325 186.443 39.9776 187.221 36.0657C187.999 32.1537 189.92 28.5604 192.74 25.74C195.56 22.9197 199.154 20.999 203.066 20.2208C206.978 19.4427 211.033 19.8421 214.717 21.3684C218.402 22.8948 221.552 25.4796 223.768 28.796C225.984 32.1124 227.167 36.0114 227.167 40C227.167 45.3485 225.042 50.478 221.26 54.26C217.478 58.042 212.349 60.1667 207 60.1667Z",
    fill: "url(#paint1_linear_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 19.8333C203.011 19.8333 199.112 21.0161 195.796 23.232C192.48 25.448 189.895 28.5976 188.368 32.2826C186.842 35.9675 186.443 40.0224 187.221 43.9343C187.999 47.8463 189.92 51.4396 192.74 54.26C195.56 57.0804 199.154 59.001 203.066 59.7792C206.978 60.5573 211.033 60.1579 214.717 58.6316C218.402 57.1052 221.552 54.5204 223.768 51.204C225.984 47.8876 227.167 43.9886 227.167 40C227.167 37.3517 226.645 34.7293 225.632 32.2826C224.618 29.8358 223.133 27.6127 221.26 25.74C219.387 23.8674 217.164 22.3819 214.717 21.3684C212.271 20.355 209.648 19.8333 207 19.8333ZM207 59.25C203.193 59.25 199.471 58.121 196.305 56.0058C193.14 53.8906 190.672 50.8841 189.215 47.3667C187.758 43.8492 187.377 39.9786 188.12 36.2445C188.863 32.5104 190.696 29.0804 193.388 26.3882C196.08 23.696 199.51 21.8627 203.245 21.1199C206.979 20.3771 210.849 20.7583 214.367 22.2153C217.884 23.6723 220.891 26.1396 223.006 29.3053C225.121 32.4709 226.25 36.1927 226.25 40C226.25 45.1054 224.222 50.0017 220.612 53.6118C217.002 57.2219 212.105 59.25 207 59.25Z",
    fill: "url(#paint2_linear_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 60.2583C202.993 60.2583 199.077 59.0702 195.745 56.8442C192.414 54.6182 189.817 51.4543 188.284 47.7525C186.75 44.0508 186.349 39.9775 187.131 36.0478C187.913 32.1181 189.842 28.5084 192.675 25.6752C195.508 22.842 199.118 20.9126 203.048 20.1309C206.978 19.3493 211.051 19.7504 214.753 21.2837C218.454 22.817 221.618 25.4136 223.844 28.7451C226.07 32.0765 227.258 35.9933 227.258 40C227.252 45.371 225.116 50.5203 221.318 54.3181C217.52 58.116 212.371 60.2523 207 60.2583ZM207 19.925C203.03 19.925 199.148 21.1024 195.847 23.3083C192.546 25.5141 189.973 28.6494 188.453 32.3176C186.934 35.9859 186.536 40.0223 187.311 43.9164C188.085 47.8106 189.997 51.3876 192.805 54.1952C195.612 57.0027 199.189 58.9147 203.084 59.6893C206.978 60.4639 211.014 60.0663 214.682 58.5469C218.351 57.0275 221.486 54.4544 223.692 51.1531C225.898 47.8518 227.075 43.9705 227.075 40C227.069 34.6776 224.952 29.5748 221.189 25.8113C217.425 22.0477 212.322 19.9308 207 19.925Z",
    fill: "#FAAF5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.856 42.6583C223.719 43.3 222.035 43.1827 221.53 43.1735C221.351 43.1823 221.18 43.2476 221.041 43.3602C220.901 43.4727 220.802 43.6266 220.755 43.7996C220.261 43.8709 219.763 43.9141 219.263 43.9288C217.741 43.8986 217.338 43.3358 217.338 43.3358C216.647 43.3238 216.593 43.9463 215.938 44.1516C215.572 44.2643 215.106 43.5182 215.106 43.5182C214.062 43.6222 213.008 43.5463 211.989 43.2936C211.559 42.9948 210.684 41.4474 210.36 41.4383C210.191 41.4251 210.022 41.4251 209.854 41.4383C209.395 41.4896 209.157 41.9305 209.212 42.6538C209.267 43.377 209.45 44.7914 209.553 45.2773C209.747 46.1939 211.507 46.578 212.255 46.9667L212.322 47.3425C211.455 47.2288 209.389 46.9896 209.802 47.4773L210.451 48.2106V48.5241C209.369 48.011 208.196 47.7151 207 47.6533C205.799 47.6478 204.616 47.9424 203.558 48.5103L203.524 48.1657L204.241 47.4617C204.536 47.1583 203.599 47.1528 202.187 47.2298L202.279 46.8475C203.118 46.5973 204.423 46.4543 204.585 45.5972C204.725 44.8528 204.901 42.8545 204.901 42.8545C205.023 41.7215 204.162 41.0212 203.672 41.1752C203.224 41.3129 202.808 41.5416 202.451 41.8471C202.286 42.1129 202.578 42.5126 202.543 43.0708C202.526 43.3889 201.506 43.4045 200.321 43.3284C199.827 43.2963 198.974 44.2451 198.763 44.2836C198.438 44.325 198.111 44.3464 197.784 44.3478C197.519 44.3569 197.234 43.817 196.766 43.7895C196.505 43.7739 196.131 44.3047 195.951 44.2918C195.379 44.2271 194.823 44.0626 194.307 43.806C194.143 43.729 194.453 42.706 194.415 42.6528C194.08 42.5778 193.73 42.5997 193.407 42.7161C193.252 42.816 192.816 43.2083 192.724 43.2267C191.986 43.442 191.204 43.4644 190.455 43.2918C190.445 42.8184 190.52 42.347 190.677 41.9003C191.092 41.4777 191.923 40.7746 191.797 40.5399C191.711 40.3804 190.938 39.8689 191.086 39.6233C191.188 39.4574 191.298 39.2967 191.417 39.142C191.612 38.9018 192.058 39.2218 192.306 39.0833C192.553 38.9449 192.698 38.5205 192.796 38.4884C193.048 38.4402 193.304 38.4245 193.56 38.4417C193.722 38.4508 193.965 39.1182 194.087 39.12C194.379 39.12 194.702 39.1594 194.807 38.9642C194.974 38.6075 195.068 38.221 195.082 37.8275C195.076 37.4388 193.97 37.1226 193.959 36.9108C193.949 36.6991 194.304 35.5432 194.501 35.4772C194.794 35.38 195.32 35.1765 195.29 34.9904C195.198 34.4212 194.896 33.2909 195.049 33.1571C195.358 32.9007 195.684 32.6655 196.026 32.4531C196.215 32.3266 196.502 32.4769 196.778 32.6034C196.935 32.7009 197.122 32.7377 197.304 32.7068C197.486 32.6759 197.651 32.5794 197.766 32.4357C197.884 32.234 197.849 31.0653 198.004 30.9608C198.253 30.7939 198.646 30.5996 198.78 30.5235C198.954 30.4254 199.576 30.8178 199.685 30.6922C200.044 30.276 200.256 29.9882 200.201 29.7755C200.031 29.2985 199.928 28.7998 199.898 28.2942C200.02 27.9864 200.173 27.6922 200.356 27.416C200.582 27.119 201.407 27.2868 201.739 27.0008C202.198 26.6038 201.979 26.2326 202.573 26.1675C203.318 25.9754 204.021 25.6468 204.646 25.1986C205.39 25.0953 206.147 25.1389 206.874 25.3269C207.158 25.3058 207.673 24.8466 207.92 24.8182C208.409 24.8267 208.894 24.9108 209.357 25.0675C209.564 25.1592 209.593 26.0832 210.075 26.2482C210.447 26.3857 210.831 26.4864 211.223 26.5488C212.202 26.6735 212.49 25.8806 212.827 25.9631C213.308 26.1109 213.726 26.4156 214.013 26.8284C214.277 27.1676 213.825 28.3868 214.457 28.6526C215.255 28.9872 216.101 29.8763 216.035 30.1275C215.943 30.485 215.531 31.1872 215.72 31.4484C215.817 31.5832 216.465 31.4108 216.717 31.3568C217.069 31.3314 217.419 31.4286 217.708 31.6318C217.895 31.9125 218.131 32.158 218.404 32.3568C218.828 32.5631 219.467 32.8482 219.529 33.0306C219.738 33.6429 219.238 34.489 219.324 34.7723C219.33 34.7933 220.125 35.0628 220.216 35.2883C220.233 35.8351 220.223 36.3825 220.185 36.9283C220.59 36.795 221.024 36.7819 221.436 36.8907C221.767 37.0117 221.907 37.4205 222.047 37.9146C222.085 38.0457 222.505 38.1098 222.553 38.2153C222.802 38.812 222.779 39.2071 222.53 39.3098C221.98 39.5389 220.697 39.9808 220.88 40.495C220.908 40.6418 220.986 40.7742 221.102 40.8694C221.217 40.9646 221.361 41.0167 221.511 41.0166C222.056 41.0274 222.596 41.1201 223.113 41.2916C223.346 41.434 223.538 41.6353 223.668 41.8753C223.798 42.1153 223.863 42.3854 223.856 42.6583Z",
    fill: "url(#paint3_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.612 34.8667L220.128 35.2031C220.163 35.2312 220.191 35.2674 220.208 35.3085L220.673 35.0124C220.66 34.961 220.639 34.9119 220.612 34.8667Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.666 34.9849L220.199 35.2874L220.206 35.3003C220.219 35.3703 220.225 35.4416 220.223 35.5129L220.687 35.2068V35.1151C220.686 35.0709 220.679 35.0271 220.666 34.9849Z",
    fill: "#8D4428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.687 35.1866L220.223 35.4937V35.8814L220.691 35.5404L220.687 35.1866Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.69 35.5193L220.222 35.8594L220.183 36.9594L220.218 36.9466L220.761 36.2618L220.7 36.2701C220.667 36.2793 220.691 36.1253 220.69 35.5193Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.275 31.4539L217.855 31.838L218.098 32.1231L218.535 31.761C218.439 31.6672 218.352 31.5643 218.275 31.4539Z",
    fill: "#E48E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 31.7436L218.082 32.1038C218.143 32.1703 218.209 32.2316 218.281 32.2872L218.722 31.8829C218.648 31.8459 218.579 31.7991 218.518 31.7436Z",
    fill: "#DB7B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74 36.2673L220.19 36.9585C220.314 36.9179 220.442 36.8873 220.571 36.8668L221.114 36.2554C220.989 36.2457 220.864 36.2497 220.74 36.2673Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.555 36.8696L220.729 36.8448L221.246 36.2692L221.096 36.2536L220.555 36.8696ZM217.705 31.651L217.874 31.8609L218.292 31.475L218.05 31.1826C217.922 31.0535 217.761 30.9614 217.586 30.9158L217.06 31.3971C217.294 31.4193 217.518 31.5073 217.705 31.651Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.687 24.9401L207.646 24.4103C207.483 24.4847 207.325 24.5708 207.174 24.6678L207.219 25.2178L207.687 24.9401Z",
    fill: "#BC6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.225 36.2664L220.709 36.8476C220.746 36.8476 220.808 36.8384 220.848 36.8366L221.346 36.2866L221.225 36.2664Z",
    fill: "#FFCB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.327 36.2838L220.827 36.8338C221.041 36.8158 221.257 36.8433 221.46 36.9145L221.783 36.4406C221.64 36.3644 221.486 36.3115 221.327 36.2838Z",
    fill: "#FFD68E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.415 32.3761L218.555 32.4448L219.014 32.0213L218.84 31.9434L218.696 31.8719L218.258 32.2734C218.306 32.3139 218.359 32.3484 218.415 32.3761Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.939 24.8383C208.012 24.8324 208.086 24.8324 208.16 24.8383L208.19 24.3369L207.988 24.3241C207.861 24.33 207.736 24.3611 207.621 24.4158L207.663 24.9474C207.747 24.8948 207.841 24.8579 207.939 24.8383Z",
    fill: "#D57C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.183 25.0244L209.507 24.6165C209.071 24.4845 208.623 24.3907 208.171 24.336L208.139 24.8383C208.492 24.8677 208.841 24.93 209.183 25.0244Z",
    fill: "#FFCD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.347 25.0813C209.403 25.106 209.451 25.1968 209.5 25.3306L209.854 24.8814C209.802 24.7797 209.717 24.6985 209.613 24.6504L209.487 24.6101L209.161 25.018C209.224 25.0354 209.286 25.0565 209.347 25.0813Z",
    fill: "#EFA952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.632 25.7064L210.008 25.2032C209.963 25.085 209.907 24.9709 209.843 24.8622L209.491 25.3104L209.632 25.7064Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.96 26.2069L210.293 25.7559C210.173 25.6798 210.097 25.4222 210 25.1839L209.624 25.6862C209.684 25.8882 209.801 26.0688 209.96 26.2069Z",
    fill: "#E48E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.078 26.2683C210.513 26.4374 210.969 26.5454 211.434 26.5892L211.5 26.0667C211.07 26.0626 210.649 25.9507 210.273 25.7412L209.941 26.1922C209.982 26.225 210.028 26.2507 210.078 26.2683Z",
    fill: "#FFCD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.463 26.151L212.534 25.4809C212.349 25.5677 212.175 25.6783 212.019 25.81L211.905 26.5067C212.11 26.4206 212.299 26.3003 212.463 26.151Z",
    fill: "#DB7B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.924 26.4993L212.042 25.7917C211.885 25.9355 211.691 26.031 211.482 26.0667L211.416 26.5873C211.589 26.5922 211.762 26.5623 211.924 26.4993Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.838 25.9832L212.944 26.0144L213.047 25.4965C212.959 25.4611 212.867 25.4397 212.772 25.4333C212.684 25.4346 212.597 25.4533 212.517 25.4882L212.445 26.1675C212.592 26.0456 212.712 25.953 212.838 25.9832Z",
    fill: "#EB962A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.279 26.1693L213.386 25.656C213.271 25.5907 213.151 25.5349 213.027 25.4892L212.924 26.008C213.049 26.0476 213.168 26.1017 213.279 26.1693Z",
    fill: "#FFC378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.587 26.3948L213.782 25.9081C213.649 25.8115 213.51 25.7237 213.366 25.645L213.26 26.1583C213.376 26.2268 213.486 26.306 213.587 26.3948Z",
    fill: "#FFCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.971 26.8L214.392 26.4838C214.212 26.2575 213.999 26.0589 213.761 25.8943L213.567 26.3783C213.715 26.506 213.85 26.6472 213.971 26.8Z",
    fill: "#FFD79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.058 26.9467L214.499 26.657C214.483 26.6196 214.462 26.584 214.439 26.5507L214.37 26.459L213.949 26.7771L214.007 26.8504C214.03 26.8793 214.047 26.9119 214.058 26.9467Z",
    fill: "#EEAF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.091 27.7277L214.619 27.3491C214.627 27.0978 214.58 26.8478 214.484 26.6158L214.051 26.9183C214.108 27.1841 214.122 27.4575 214.091 27.7277Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.191 28.4207L214.655 28.0659C214.626 27.8226 214.614 27.5776 214.618 27.3326L214.091 27.7121C214.07 27.9528 214.105 28.1951 214.191 28.4207Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.301 28.5701L214.75 28.2282C214.721 28.2069 214.697 28.1794 214.68 28.1477C214.663 28.116 214.653 28.0809 214.651 28.0448L214.182 28.3996C214.21 28.4638 214.251 28.5217 214.301 28.5701Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.733 28.2172L214.281 28.5508C214.327 28.6006 214.384 28.6396 214.447 28.6654L214.544 28.7094L214.983 28.3803L214.733 28.2172Z",
    fill: "#FCB664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.918 28.9193L215.321 28.6232L214.963 28.3675L214.525 28.7003C214.661 28.7648 214.792 28.838 214.918 28.9193Z",
    fill: "#FFC378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.838 29.7333L216.227 29.4528C215.949 29.1391 215.639 28.8555 215.301 28.6068L214.898 28.9047C215.252 29.1305 215.569 29.41 215.838 29.7333Z",
    fill: "#FFD68E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.966 29.924L216.361 29.6298C216.315 29.5641 216.265 29.5005 216.213 29.4391L215.823 29.7141C215.877 29.7798 215.924 29.85 215.966 29.924Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.023 30.1403L216.481 29.8204C216.444 29.7487 216.401 29.6797 216.354 29.6142L215.958 29.902C216.008 29.9708 216.031 30.0556 216.023 30.1403Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.025 30.1339C215.999 30.2256 215.939 30.386 215.89 30.5116L216.553 30.0679C216.543 29.9741 216.514 29.8834 216.467 29.8012L216.026 30.1202L216.025 30.1339Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.744 31.4878L216.419 30.8462C216.298 30.8132 216.453 30.5107 216.544 30.1642C216.554 30.1234 216.557 30.0811 216.551 30.0395L215.902 30.4758C215.708 30.9663 215.605 31.2871 215.724 31.464C215.729 31.4734 215.736 31.4816 215.744 31.4878Z",
    fill: "#994822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.918 31.5199L216.669 30.8315L216.474 30.8517C216.461 30.8552 216.448 30.856 216.435 30.8541C216.423 30.8522 216.41 30.8476 216.399 30.8407L215.724 31.4686C215.751 31.5053 215.817 31.5208 215.918 31.5199Z",
    fill: "#FCB664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.717 31.3833C216.839 31.3683 216.963 31.3738 217.083 31.3998L217.6 30.9204C217.287 30.8345 216.961 30.8035 216.637 30.8288L215.886 31.5153C216.167 31.4978 216.445 31.4536 216.717 31.3833Z",
    fill: "#FFD68E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.093 32.7153L219.601 32.3385C219.408 32.2127 219.204 32.1032 218.993 32.0113L218.534 32.4329L219.093 32.7153Z",
    fill: "#FFD79D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.375 32.8867L219.88 32.5741C219.791 32.4777 219.691 32.393 219.58 32.322L219.073 32.7015C219.177 32.7568 219.278 32.8187 219.375 32.8867Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.533 33.0718L220.022 32.8142C219.985 32.7175 219.929 32.629 219.858 32.5539L219.349 32.8711C219.423 32.9155 219.484 32.9787 219.526 33.0544L219.533 33.0718Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.516 33.8501L220.062 33.5128C220.094 33.2718 220.078 33.0269 220.014 32.7923L219.526 33.0498C219.595 33.3126 219.592 33.5891 219.516 33.8501Z",
    fill: "#8D4428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.314 34.7924L219.341 34.8043L219.897 34.4505L219.907 34.4175C219.983 34.1134 220.035 33.8039 220.063 33.4917L219.521 33.8281C219.406 34.1379 219.336 34.4627 219.314 34.7924Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.57 34.9006L220.092 34.5293C219.964 34.4817 219.896 34.4533 219.909 34.4175L219.315 34.7924C219.316 34.7998 219.437 34.8465 219.57 34.9006Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.149 35.2223L220.631 34.9006C220.494 34.7122 220.296 34.5778 220.07 34.5211L219.548 34.8878C219.765 34.9668 219.967 35.0797 220.149 35.2223Z",
    fill: "#FFD68E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.758 36.4333L221.436 36.9108C221.538 36.9491 221.627 37.0155 221.693 37.1024L222.031 36.6643C221.957 36.5693 221.864 36.4906 221.758 36.4333Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.245 37.0245C222.187 36.888 222.111 36.76 222.019 36.6441L221.68 37.0813C221.766 37.1876 221.834 37.3079 221.88 37.437L222.245 37.0245Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.033 37.9274C222.047 37.976 222.113 38.0191 222.217 38.0603L222.607 37.6213L222.523 37.5635C222.39 37.3977 222.29 37.2079 222.23 37.0043L221.863 37.4168C221.929 37.584 221.985 37.7544 222.033 37.9274Z",
    fill: "#D47429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.593 37.6066L222.199 38.0502C222.34 38.1117 222.523 38.1612 222.55 38.2272L222.561 38.2528L222.905 37.8211C222.824 37.7542 222.703 37.6808 222.593 37.6066Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.884 37.8L222.55 38.2235L222.6 38.35L222.998 37.9164C222.967 37.8716 222.928 37.8322 222.884 37.8Z",
    fill: "#E7944B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.646 39.2098L223.131 39.3638C223.271 38.8962 223.23 38.3929 223.016 37.954C223.007 37.9335 222.995 37.9143 222.981 37.8972L222.589 38.3243C222.746 38.7341 222.767 39.0503 222.646 39.2098Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.527 39.3015L221.545 39.7287L222.161 39.9982L222.886 39.6608C223.009 39.5903 223.1 39.475 223.14 39.3391L222.661 39.1888C222.629 39.2391 222.582 39.2785 222.527 39.3015Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.187 39.9853L221.57 39.7158C221.451 39.7759 221.336 39.8433 221.225 39.9175L221.867 40.1348L222.187 39.9853Z",
    fill: "#823D1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.245 39.9083C221.109 39.9897 220.993 40.0999 220.905 40.231L221.573 40.297C221.611 40.2624 221.654 40.2337 221.7 40.2118L221.889 40.1274L221.245 39.9083Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.595 40.275L220.918 40.2072C220.885 40.2523 220.864 40.3052 220.857 40.3607C220.851 40.4163 220.858 40.4726 220.879 40.5243L221.497 40.4437C221.483 40.385 221.54 40.3181 221.595 40.275Z",
    fill: "#823D1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.494 40.4198L220.872 40.5005C220.903 40.5902 220.944 40.6758 220.996 40.7553L221.624 40.5014C221.519 40.495 221.493 40.4583 221.494 40.4198Z",
    fill: "#BA6019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.197 40.9478L221.851 40.5161L221.592 40.4978L220.984 40.737C221.036 40.824 221.11 40.8965 221.197 40.9478Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.516 41.0358L221.64 41.0496L222.33 40.5555L221.829 40.5152L221.187 40.9405C221.289 40.996 221.401 41.0286 221.516 41.0358Z",
    fill: "#D47429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.467 41.1348L223.089 40.7022C222.834 40.6297 222.573 40.5797 222.309 40.5527L221.618 41.0468L222.467 41.1348Z",
    fill: "#E7944B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12 41.3145C223.186 41.3474 223.247 41.3887 223.303 41.4373L223.761 41.1128C223.628 40.9601 223.461 40.8408 223.274 40.7645C223.204 40.7388 223.133 40.7159 223.062 40.6958L222.436 41.1312C222.671 41.1594 222.902 41.2211 223.12 41.3145Z",
    fill: "#FFCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.543 41.6995L223.987 41.4071C223.916 41.2933 223.835 41.1865 223.744 41.0881L223.286 41.4153C223.384 41.4975 223.471 41.5932 223.543 41.6995Z",
    fill: "#D89050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.842 42.6501C223.826 42.7148 223.795 42.7746 223.75 42.8243L224.245 43.113C224.31 43.0083 224.349 42.8899 224.359 42.7674C224.373 42.2768 224.236 41.7936 223.968 41.3823L223.524 41.6766C223.746 41.9511 223.859 42.2976 223.842 42.6501Z",
    fill: "#BC6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.262 43.0892L223.77 42.8023C223.547 43.0983 222.89 43.1689 222.296 43.1735L222.479 43.7327C223.183 43.7043 223.982 43.575 224.262 43.0892Z",
    fill: "#8D4428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.524 43.1579C221.443 43.1566 221.362 43.168 221.284 43.1918L221.44 43.7327H221.463C221.542 43.7198 221.984 43.7574 222.503 43.7327L222.319 43.1735C221.991 43.1772 221.691 43.1616 221.524 43.1579Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.817 43.6071L221.057 44.2781C221.247 44.1259 221.264 43.7565 221.463 43.7281L221.306 43.1845C221.201 43.2183 221.103 43.2732 221.019 43.3458C220.934 43.4185 220.866 43.5073 220.817 43.6071Z",
    fill: "#8D4428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.081 44.257L220.832 43.5823C220.789 43.6562 220.755 43.735 220.731 43.817L220.923 44.3459C220.963 44.3346 221.001 44.3176 221.036 44.2955C221.052 44.2839 221.067 44.271 221.081 44.257Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.263 43.9142C217.741 43.883 217.348 43.3138 217.348 43.3138H217.33L217.155 43.9554C217.2 43.9662 217.242 43.9859 217.28 44.0132C217.886 44.3355 218.565 44.4977 219.251 44.4843C219.82 44.501 220.388 44.4505 220.945 44.334L220.741 43.7794C220.251 43.853 219.758 43.898 219.263 43.9142Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.563 43.7088L216.367 44.5668C216.581 44.4399 216.776 44.2835 216.946 44.1021C217.077 43.982 217.117 43.9463 217.179 43.9646L217.348 43.3138C217.196 43.3146 217.045 43.3508 216.909 43.4193C216.773 43.4878 216.654 43.5869 216.563 43.7088Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.916 44.136L215.787 44.7282C216.001 44.7266 216.21 44.666 216.391 44.5531L216.586 43.6859C216.409 43.8951 216.177 44.051 215.916 44.136Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.116 43.4962H215.093L214.802 44.0663H214.827C214.922 44.2511 215.061 44.4086 215.234 44.5239C215.406 44.6391 215.605 44.7082 215.812 44.7245L215.942 44.125C215.579 44.2423 215.116 43.4962 215.116 43.4962Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.987 43.2615L211.657 43.7363C212.238 43.9742 212.862 44.0885 213.49 44.0718L213.732 43.5218C213.139 43.5474 212.546 43.459 211.987 43.2615Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.365 41.4163C210.251 41.4163 210.11 41.4098 209.99 41.4163L210.091 41.9663C210.162 41.9543 210.212 41.9947 210.274 42.0423C210.618 42.3063 211.436 43.6291 211.682 43.7538L212.01 43.2808C211.583 42.9801 210.69 41.4254 210.365 41.4163Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.013 41.4144C209.871 41.4089 209.73 41.4405 209.604 41.5061L209.886 42.0286C209.954 41.9847 210.034 41.9621 210.115 41.9635L210.013 41.4144Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.325 41.804L209.774 42.3045C209.771 42.2488 209.782 42.1932 209.805 42.1424C209.828 42.0916 209.863 42.047 209.907 42.0121L209.623 41.4942C209.493 41.5624 209.388 41.6711 209.325 41.804Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.709 43.52L213.466 44.07H214.827L215.116 43.4953C214.648 43.5296 214.178 43.5378 213.709 43.52Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.195 42.5548L209.802 42.9553C209.77 42.728 209.762 42.4978 209.778 42.2688L209.338 41.7783C209.221 42.0193 209.171 42.2877 209.195 42.5548Z",
    fill: "#94441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.579 45.3928L210.097 45.2232C209.979 44.462 209.879 43.6978 209.8 42.9315L209.194 42.5309C209.269 43.4913 209.397 44.4467 209.579 45.3928Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.095 45.2103L209.57 45.3689C209.615 45.4996 209.686 45.6195 209.779 45.7209L210.258 45.4193C210.181 45.3704 210.123 45.2967 210.095 45.2103Z",
    fill: "#DD8732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.231 45.3973L209.756 45.6943C209.947 45.9042 210.176 46.0764 210.43 46.2022L210.788 45.7438C210.59 45.6488 210.404 45.5327 210.231 45.3973Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.267 46.578L211.556 46.0922L210.757 45.7255L210.401 46.1838C210.682 46.332 210.971 46.4636 211.267 46.578Z",
    fill: "#FFC278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.966 46.853L212.241 46.3773L211.528 46.0812L211.24 46.567L211.966 46.853Z",
    fill: "#EA913E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.275 46.9969L212.618 46.5972C212.5 46.496 212.364 46.418 212.217 46.3672L211.942 46.8429L212.275 46.9969Z",
    fill: "#C57231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.324 47.3682L212.84 47.8503C212.946 47.7733 212.854 47.2334 212.744 46.8897C212.72 46.7751 212.67 46.6676 212.598 46.5753L212.25 46.9841L212.324 47.3682Z",
    fill: "#94441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.559 47.2417L212.049 47.7834L212.67 47.8751C212.792 47.8925 212.832 47.8696 212.859 47.8283L212.317 47.3333L211.559 47.2417ZM210.444 48.5388L210.88 49.0933C211.001 49.0319 210.983 48.6506 210.972 48.3884L210.45 48.2198L210.444 48.5388Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.747 47.7092C211.192 47.696 211.637 47.7224 212.077 47.788L211.583 47.2463C210.788 47.1665 209.779 47.1106 209.736 47.3526L210.711 47.7688C210.689 47.7165 210.724 47.7101 210.747 47.7092Z",
    fill: "#642813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.707 47.7275L209.75 47.3333C209.732 47.3728 209.744 47.425 209.795 47.4818L210.48 48.2583L210.975 48.4187C210.968 48.3194 210.95 48.2211 210.923 48.1253C210.86 47.942 210.683 47.7798 210.707 47.7275Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.229 48.4058L210.255 49.0099C210.63 49.1502 210.827 49.1474 210.903 49.0759L210.445 48.4975L210.229 48.4058Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.412 47.6523L207.292 48.2207C208.234 48.2893 209.156 48.524 210.016 48.9137L210.281 49.0191L210.253 48.4168C209.354 48.0103 208.394 47.7522 207.412 47.6523Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.77 48.4003L203.505 49.0988C204.674 48.4714 205.991 48.1688 207.317 48.2225L207.436 47.6542C206.169 47.562 204.9 47.8202 203.77 48.4003Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.548 48.5058L203.166 49.1474C203.233 49.1923 203.362 49.1639 203.542 49.0805L203.808 48.3793L203.548 48.5058Z",
    fill: "#56220C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.122 49.0915C203.127 49.1085 203.137 49.1239 203.15 49.1363C203.163 49.1488 203.179 49.1579 203.196 49.163L203.579 48.4911L203.55 48.1363L203.022 48.1235C202.984 48.4496 203.018 48.7801 203.122 49.0915Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.385 47.6707C203.53 47.7119 203.054 47.9411 203.013 48.1547L203.552 48.1675L204.269 47.4644C204.307 47.4259 204.339 47.3727 204.317 47.3324L203.385 47.6707Z",
    fill: "#94441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.751 47.1848L203.148 47.6542C203.355 47.6597 203.399 47.6652 203.41 47.6872L204.327 47.3617C204.322 47.2627 204.124 47.2068 203.751 47.1848Z",
    fill: "#56220C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.175 47.2133L201.641 47.5928C201.742 47.7926 202.54 47.6276 203.178 47.6551L203.779 47.1867C203.244 47.1671 202.709 47.1759 202.175 47.2133Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.314 46.8264L202.016 46.4277C201.781 46.746 201.647 47.1271 201.63 47.5222C201.628 47.5386 201.629 47.5554 201.634 47.5713C201.639 47.5872 201.647 47.6017 201.659 47.6138L202.216 47.2068L202.314 46.8264Z",
    fill: "#94441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.313 46.6L202.906 46.1536L202.088 46.3873C202.053 46.4011 202.022 46.4224 201.996 46.4497L202.307 46.8658L203.313 46.6Z",
    fill: "#BC6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92 46.3745L203.48 45.9382C203.284 46.025 203.082 46.0991 202.876 46.16L203.282 46.6064C203.501 46.5469 203.714 46.4693 203.92 46.3745Z",
    fill: "#F49E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.425 45.9977L203.994 45.5733C203.849 45.7406 203.665 45.8693 203.458 45.9483L203.897 46.3846C204.1 46.2976 204.281 46.1653 204.425 45.9977Z",
    fill: "#DD8732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.603 45.6128C204.743 44.8684 204.936 42.7638 204.93 42.6446L204.348 42.8068L204.068 45.4212C204.05 45.485 204.019 45.5442 203.976 45.5944L204.406 46.0179C204.506 45.9028 204.574 45.763 204.603 45.6128Z",
    fill: "#76310A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.604 41.6161L204.174 41.9406C204.333 42.208 204.394 42.5223 204.346 42.8298L204.93 42.6675C204.936 42.2912 204.822 41.9228 204.604 41.6161Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.684 41.1559C203.221 41.2971 202.792 41.5352 202.428 41.8544L203.015 42.2523C202.948 41.9928 203.703 41.6848 203.84 41.6885C203.914 41.7062 203.984 41.74 204.043 41.7876C204.103 41.8351 204.151 41.8952 204.185 41.9635L204.617 41.6372C204.526 41.4744 204.389 41.342 204.223 41.2564C204.057 41.1709 203.87 41.1359 203.684 41.1559Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.435 41.8425C202.323 42.0258 202.424 42.266 202.488 42.5566L203.112 43.0296C203.106 42.7598 203.072 42.4914 203.012 42.2284L202.44 41.8333L202.435 41.8425Z",
    fill: "#964C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.539 43.0589C202.537 43.0928 202.523 43.1251 202.501 43.1506L202.868 43.5603C202.947 43.4928 203.01 43.4083 203.053 43.3131C203.095 43.2179 203.115 43.1145 203.112 43.0103L202.482 42.5318C202.526 42.7039 202.545 42.8814 202.539 43.0589Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.115 43.3L202.343 43.773C202.543 43.7537 202.732 43.6726 202.883 43.5411L202.517 43.1304C202.409 43.2351 202.265 43.2956 202.115 43.3Z",
    fill: "#94441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.308 43.3083L200.428 43.8418L202.37 43.7721L202.142 43.3C201.532 43.3595 200.918 43.3622 200.308 43.3083Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.405 43.7904L199.572 44.3789C199.784 44.1661 200.028 43.9877 200.295 43.85C200.328 43.85 200.38 43.8427 200.447 43.8408L200.324 43.3092C199.975 43.3693 199.653 43.5376 199.405 43.7904Z",
    fill: "#994B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.428 43.7703C199.1 44.0269 198.862 44.2671 198.742 44.2753L198.889 44.8043C199.156 44.7121 199.398 44.5597 199.596 44.3588L199.428 43.7703Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.799 44.3285C197.565 44.3358 197.288 43.8922 196.905 43.7923L196.875 44.3358C196.934 44.3503 196.988 44.3822 197.029 44.4275C197.2 44.6582 197.455 44.8126 197.738 44.8574C198.131 44.8643 198.524 44.8447 198.914 44.7988L198.764 44.2698C198.444 44.3089 198.122 44.3285 197.799 44.3285Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.775 43.7703C196.598 43.7593 196.361 44.0058 196.179 44.1571L196.286 44.7447C196.445 44.6371 196.594 44.5143 196.73 44.378C196.752 44.3578 196.779 44.344 196.809 44.338C196.838 44.3321 196.869 44.3342 196.897 44.3441L196.929 43.8014C196.879 43.7848 196.827 43.7743 196.775 43.7703Z",
    fill: "#A35622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.199 44.1397C196.134 44.2112 196.048 44.26 195.953 44.279H195.937L195.973 44.829C196.092 44.8282 196.207 44.7942 196.307 44.7309L196.199 44.1397Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.329 43.7932C194.319 43.7886 194.305 43.7794 194.294 43.7455L193.836 44.0425C193.919 44.158 194.029 44.2522 194.156 44.3175C194.737 44.5897 195.359 44.7641 195.996 44.8336L195.952 44.2836C195.386 44.2181 194.837 44.052 194.329 43.7932Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.383 43.0003L193.777 43.4705L193.747 43.7391C193.738 43.8578 193.777 43.975 193.854 44.0654L194.304 43.7693C194.274 43.5103 194.301 43.2479 194.383 43.0003Z",
    fill: "#AF6638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.442 42.64L194.419 42.6299L193.726 43.2001H193.756C193.8 43.2001 193.795 43.2798 193.772 43.4953L194.375 43.0278C194.412 42.9016 194.435 42.7714 194.442 42.64Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.535 42.651L193.585 43.3147L193.691 43.234C193.71 43.2168 193.734 43.2045 193.759 43.1983L194.444 42.64C194.144 42.5772 193.834 42.581 193.535 42.651Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.403 42.7033C193.297 42.7729 193.036 42.9929 192.87 43.1194L193.118 43.652C193.289 43.5444 193.454 43.4256 193.609 43.2963L193.561 42.6446C193.505 42.6558 193.452 42.6756 193.403 42.7033Z",
    fill: "#A5572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.727 43.2083C191.991 43.4343 191.207 43.4558 190.46 43.2707L189.973 43.5457L189.986 43.5722C190.207 43.8582 191.188 44.0397 192.814 43.7611C192.93 43.7423 193.041 43.7019 193.143 43.6419L192.893 43.1066C192.843 43.1487 192.787 43.183 192.727 43.2083Z",
    fill: "#6C2B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.626 42.0946L190.133 41.8902C189.979 42.4354 189.929 43.0048 189.986 43.5686L190.486 43.2798C190.493 42.8811 190.54 42.484 190.626 42.0946Z",
    fill: "#A5572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.701 41.9158L190.902 41.7169L190.413 41.3915C190.349 41.4569 190.292 41.5285 190.242 41.6051C190.19 41.703 190.151 41.8075 190.127 41.9158L190.619 42.1203C190.632 42.0471 190.66 41.9775 190.701 41.9158Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.828 40.5619L191.048 40.6536L191.069 40.6811C191.133 40.7911 190.674 41.1101 190.391 41.4144L190.88 41.7389C191.287 41.3438 191.892 40.7847 191.828 40.5619Z",
    fill: "#D27C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.821 40.5418C191.685 40.392 191.538 40.252 191.382 40.1228L190.713 40.1714C190.822 40.3448 190.939 40.5125 191.066 40.6738L191.833 40.5821C191.831 40.568 191.827 40.5544 191.821 40.5418Z",
    fill: "#7A2C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.093 39.6792L190.506 39.6608C190.535 39.8532 190.611 40.0356 190.726 40.1925L191.403 40.143C191.24 39.9899 191.073 39.8093 191.093 39.6792Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.222 39.4564L190.666 39.2933C190.627 39.3547 190.564 39.4711 190.527 39.5463C190.509 39.5889 190.502 39.6358 190.508 39.6819L191.091 39.7012C191.091 39.6544 191.104 39.6333 191.222 39.4564Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.441 39.1512C191.468 39.1173 191.504 39.0918 191.545 39.0778L191.341 38.5627C191.047 38.7516 190.808 39.0143 190.648 39.3244L191.204 39.4839L191.441 39.1512Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.912 39.0971L191.829 38.493C191.655 38.4625 191.475 38.4912 191.319 38.5746L191.521 39.087C191.649 39.0493 191.786 39.0528 191.912 39.0971Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.804 38.493L191.889 39.0925C192.004 39.1263 192.124 39.1381 192.244 39.1273L192.135 38.4793C192.026 38.4949 191.915 38.4995 191.804 38.493Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.189 38.449C192.168 38.4689 192.141 38.4811 192.112 38.4838L192.222 39.131C192.266 39.1263 192.308 39.1109 192.344 39.0861L192.189 38.449Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.622 38.7634L192.439 38.13C192.32 38.2657 192.218 38.438 192.169 38.4655L192.324 39.0989C192.449 39.0127 192.551 38.8976 192.622 38.7634Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.425 38.1502L192.608 38.7918C192.658 38.7069 192.711 38.6246 192.769 38.5453L192.608 37.9833C192.539 38.0288 192.477 38.0852 192.425 38.1502Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.813 38.5049C192.837 38.4979 192.861 38.492 192.885 38.4875L192.817 37.9128C192.772 37.9199 192.728 37.9301 192.684 37.943C192.65 37.9552 192.617 37.9719 192.587 37.9925L192.749 38.5654C192.764 38.5398 192.786 38.5189 192.813 38.5049Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.421 38.4536L193.458 37.8944C193.237 37.8797 193.015 37.8871 192.795 37.9164L192.863 38.4921C193.048 38.461 193.235 38.4481 193.421 38.4536Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.433 37.8917L193.396 38.4518L193.562 38.4563L193.7 37.9018L193.433 37.8917Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.708 37.9045H193.681L193.542 38.4545H193.563C193.589 38.459 193.614 38.4722 193.632 38.4921L193.883 37.9421C193.827 37.9185 193.768 37.9058 193.708 37.9045Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.81 38.7451L194.078 38.1117C194.027 38.0285 193.951 37.9641 193.86 37.9283L193.614 38.4783C193.695 38.5547 193.761 38.6451 193.81 38.7451Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.995 39.054L194.255 38.3885L194.057 38.0823L193.79 38.7112L193.995 39.054Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.09 39.1356H194.208L194.391 38.548C194.332 38.4893 194.28 38.4245 194.235 38.3546L193.976 39.0201C194.018 39.0888 194.058 39.1356 194.09 39.1356Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.741 39.065L194.492 38.5462L194.471 38.5581C194.419 38.5893 194.411 38.5728 194.368 38.5288L194.185 39.1374C194.374 39.1589 194.565 39.134 194.741 39.065Z",
    fill: "#A5572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.832 38.9724C194.851 38.9367 194.877 38.8807 194.895 38.8367L194.529 38.4068C194.525 38.4606 194.505 38.5122 194.473 38.5553H194.467L194.717 39.0742C194.765 39.0529 194.805 39.0173 194.832 38.9724Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.992 38.559L194.56 38.1978C194.556 38.2757 194.546 38.3533 194.531 38.4298L194.89 38.856C194.93 38.7592 194.964 38.66 194.992 38.559Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.104 37.8293C195.104 37.8052 195.099 37.7814 195.091 37.7588L194.525 37.9265C194.558 38.0203 194.568 38.1204 194.555 38.2189L194.983 38.5773C195.055 38.3341 195.096 38.0828 195.104 37.8293Z",
    fill: "#C27138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.739 37.4141L194.138 37.6442C194.327 37.7661 194.515 37.8834 194.535 37.9467L195.097 37.7798C195.023 37.6202 194.897 37.4909 194.739 37.4141Z",
    fill: "#7A2C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.311 37.1684L193.755 37.371C193.885 37.4756 194.022 37.5723 194.164 37.6607L194.764 37.4306C194.63 37.3417 194.447 37.2445 194.311 37.1684Z",
    fill: "#9A4921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.983 36.8833L193.487 37.0117C193.541 37.1661 193.643 37.2993 193.778 37.3921L194.34 37.1867C194.087 37.0392 193.971 36.9686 193.983 36.8833Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.507 36.7752L193.482 36.8998C193.475 36.9434 193.478 36.9879 193.491 37.03L193.982 36.9017C193.984 36.8398 193.992 36.7783 194.007 36.7183L193.507 36.7752Z",
    fill: "#96441E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.037 36.5983L193.551 36.5799L193.501 36.7981L194.003 36.744L194.037 36.5983Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.406 35.622L193.968 35.3699C193.781 35.7633 193.639 36.1766 193.545 36.6019L194.031 36.6203C194.115 36.2734 194.24 35.9381 194.406 35.622Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.956 35.391L194.393 35.6431C194.42 35.5928 194.456 35.5477 194.499 35.5102L194.04 35.2453C194.01 35.2924 193.982 35.3411 193.956 35.391Z",
    fill: "#F49E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.645 35.4533L194.157 35.1206C194.107 35.1613 194.064 35.2106 194.03 35.2663L194.478 35.5276C194.491 35.5143 194.506 35.5037 194.523 35.4964L194.645 35.4533Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.107 35.2388L194.608 34.9134L194.198 35.0968C194.175 35.1077 194.154 35.1219 194.135 35.1389L194.615 35.4643C194.786 35.405 194.951 35.3294 195.107 35.2388Z",
    fill: "#A04E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 34.775C194.76 34.7859 194.76 34.7971 194.757 34.808C194.713 34.861 194.655 34.9015 194.59 34.9253L195.092 35.2517C195.22 35.1756 195.33 35.083 195.315 34.9913L194.757 34.775Z",
    fill: "#F49E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.312 34.995L195.168 34.2617L194.654 34.1324C194.702 34.3528 194.736 34.576 194.756 34.8007L195.312 35.0179C195.312 35.0103 195.312 35.0026 195.312 34.995Z",
    fill: "#E69646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.037 33.4192L194.57 33.2863C194.576 33.5759 194.607 33.8645 194.662 34.1489L195.176 34.2782C195.111 33.9951 195.065 33.7082 195.037 33.4192Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.078 33.1672L195.209 33.0544L194.751 32.7235C194.679 32.8018 194.626 32.895 194.595 32.9963C194.564 33.0976 194.556 33.2045 194.572 33.3093L195.039 33.4413C195.029 33.3019 195.038 33.202 195.078 33.1672Z",
    fill: "#AA5A28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.913 32.5503L195.738 31.9728C195.388 32.2117 195.052 32.469 194.729 32.7437L195.188 33.0746C195.42 32.8876 195.662 32.7126 195.913 32.5503Z",
    fill: "#944428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.034 32.4696C196.086 32.4357 196.148 32.4194 196.21 32.4228L196.184 31.816C196.077 31.8054 195.969 31.8288 195.875 31.8829L195.715 31.9883L195.89 32.5649L196.034 32.4696Z",
    fill: "#A5572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.572 32.5237V31.9022C196.441 31.851 196.303 31.8201 196.162 31.8105L196.189 32.4183C196.323 32.4246 196.454 32.4607 196.572 32.5237Z",
    fill: "#FFC283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55 31.8948V32.5136C196.692 32.6103 196.854 32.6739 197.024 32.6994C197.193 32.725 197.367 32.7119 197.531 32.6612L197.326 32.1368C197.232 32.2083 196.889 32.0085 196.55 31.8948Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.797 32.4375L197.357 32.0553C197.357 32.1084 197.344 32.1286 197.319 32.1469L197.509 32.6749C197.63 32.6326 197.732 32.5484 197.797 32.4375Z",
    fill: "#C27138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.395 31.4475L197.356 32.0763L197.788 32.4522C197.846 32.2719 197.877 32.0841 197.88 31.8948L197.395 31.4475Z",
    fill: "#944428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.896 31.6464L197.423 31.1881L197.393 31.4704L197.876 31.9187L197.896 31.6464Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.969 31.0882L197.584 30.6793C197.486 30.838 197.43 31.0191 197.421 31.2055L197.894 31.6638C197.903 31.4702 197.928 31.2777 197.969 31.0882Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.027 30.9782L198.183 30.8782L197.822 30.4859L197.645 30.6179C197.617 30.6402 197.592 30.6664 197.571 30.6958L197.963 31.112C197.969 31.0617 197.992 31.0147 198.027 30.9782Z",
    fill: "#AA5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.658 30.6078L198.503 30.0578C198.259 30.189 198.024 30.3366 197.799 30.4997L198.158 30.8902L198.658 30.6078Z",
    fill: "#944428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.782 30.54C198.825 30.5219 198.873 30.5187 198.919 30.5308L198.75 29.9616C198.659 29.9891 198.571 30.026 198.487 30.0716L198.642 30.6216L198.782 30.54Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.041 30.5583L198.877 29.9524C198.826 29.9428 198.774 29.9479 198.725 29.9671L198.894 30.5262C198.944 30.533 198.993 30.5438 199.041 30.5583Z",
    fill: "#FFC283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.404 30.6839L199.24 30.0633C199.116 30.0148 198.987 29.9768 198.856 29.9497L199.019 30.5528C199.133 30.5849 199.285 30.6436 199.404 30.6839Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.701 30.7087L199.717 30.6894L199.511 30.1394H199.483C199.392 30.1151 199.303 30.0845 199.216 30.0478L199.38 30.6683C199.53 30.727 199.657 30.7591 199.701 30.7087Z",
    fill: "#E5872B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.878 30.4969L199.608 30.0276C199.56 30.0982 199.516 30.1449 199.487 30.144L199.701 30.7087L199.878 30.4969Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.224 29.9167L199.701 29.8094V29.8296C199.682 29.909 199.645 29.9832 199.594 30.0468L199.864 30.5143C200.026 30.3438 200.149 30.1398 200.224 29.9167Z",
    fill: "#944428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.223 29.7819L200.176 29.6105L199.626 29.4987L199.704 29.8305L200.223 29.9378C200.236 29.8866 200.236 29.833 200.223 29.7819Z",
    fill: "#B96534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.01 29L199.481 28.8873L199.628 29.5198L200.178 29.6316L200.01 29Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93 28.2878L199.437 28.1622C199.424 28.2082 199.415 28.2551 199.408 28.3024C199.408 28.5077 199.434 28.7121 199.484 28.9111L200.016 29.0229C199.911 28.5939 199.876 28.3758 199.93 28.2878Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.262 27.6113L199.944 27.1722C199.725 27.4814 199.552 27.8211 199.431 28.1805L199.92 28.3052L200.262 27.6113Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.381 27.4362C200.413 27.3971 200.454 27.3658 200.5 27.3445L200.257 26.8339C200.183 26.8792 200.118 26.9376 200.065 27.0062L199.922 27.207L200.249 27.6351C200.289 27.5662 200.333 27.4998 200.381 27.4362Z",
    fill: "#BC6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.832 27.2473L200.595 26.7028C200.467 26.7271 200.345 26.7754 200.235 26.8449L200.477 27.3546C200.587 27.2966 200.708 27.2602 200.832 27.2473Z",
    fill: "#944428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.573 26.7083L200.81 27.2519C201.139 27.1988 201.578 27.1969 201.78 27.0008L201.563 26.3692C201.403 26.6579 200.955 26.6167 200.573 26.7083Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.074 26.5846L201.837 25.9328C201.726 26.042 201.64 26.1744 201.586 26.3206C201.576 26.345 201.564 26.3683 201.549 26.3903L201.763 27.0145C201.899 26.898 202.006 26.7506 202.074 26.5846Z",
    fill: "#AD5725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.607 26.1858L202.493 25.6514C202.239 25.6716 202 25.7784 201.816 25.9539L202.057 26.6194C202.161 26.3985 202.197 26.2253 202.607 26.1858Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.286 25.9924L203.162 25.4754C202.962 25.5613 202.751 25.6183 202.536 25.645L202.471 25.6542L202.584 26.1877C202.826 26.1562 203.062 26.0905 203.286 25.9924Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.002 25.6221L203.859 25.0987C203.633 25.2499 203.392 25.3789 203.141 25.4837L203.265 26.0016C203.519 25.8929 203.766 25.7661 204.002 25.6221Z",
    fill: "#BC6327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.626 25.2417L204.512 24.6917C204.43 24.72 204.352 24.7594 204.28 24.809L203.838 25.1197L203.98 25.6413L204.626 25.2417Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.664 25.2197C204.976 25.1264 205.304 25.1026 205.625 25.15L205.593 24.6513C205.228 24.5843 204.852 24.5987 204.493 24.6935L204.608 25.2499C204.627 25.2417 204.647 25.227 204.664 25.2197Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.467 25.2646L206.436 24.7934L205.567 24.6486L205.599 25.1482C205.9 25.172 206.227 25.2215 206.467 25.2646Z",
    fill: "#FFC378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.885 25.3471H206.906L206.895 24.8301C206.734 24.8443 206.572 24.8313 206.415 24.7916L206.444 25.2628L206.885 25.3471Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24 25.2059L207.195 24.6559C207.095 24.7286 206.988 24.79 206.874 24.8393L206.885 25.3526C207.012 25.3283 207.133 25.2784 207.24 25.2059Z",
    fill: "#D57C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.004 35.8356C205.934 35.9933 205.764 36.6221 205.487 36.8109C205.12 37.0584 204.442 36.7706 204.261 36.8815C204.22 36.9143 204.188 36.9566 204.167 37.0048C204.146 37.0529 204.138 37.1054 204.142 37.1577C204.147 37.2099 204.164 37.2603 204.192 37.3044C204.22 37.3484 204.259 37.3848 204.305 37.4104C205.092 37.7743 205.858 38.1845 206.597 38.6388C206.666 38.6837 206.78 38.6067 206.816 38.4673C206.851 38.328 207.228 36.018 207.19 35.9282C207.06 35.6183 206.067 35.6972 206.004 35.8356Z",
    fill: "url(#paint4_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.672 36.2802C208.654 36.3388 208.327 38.8157 208.383 38.8468C209.085 38.2279 209.82 37.6465 210.583 37.1052C210.658 37.0557 210.622 36.9017 210.62 36.8861C210.459 36.5943 210.251 36.3311 210.004 36.1069C209.86 36.1088 208.679 36.2563 208.672 36.2802Z",
    fill: "url(#paint5_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.227 40.1219C209.21 40.2594 210.106 40.4299 210.888 40.1687C211.077 40.1054 211.352 39.3483 211.713 39.23C212.073 39.1118 212.942 39.4738 213.218 39.23C213.438 39.0375 213.392 38.4472 213.072 38.4298C212.525 38.4072 211.984 38.31 211.464 38.141C211.379 38.1227 209.329 39.2823 209.227 40.1219Z",
    fill: "url(#paint6_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.086 38.5187C203.016 38.5599 202.818 39.0687 202.616 39.2117C202.508 39.2786 202.381 39.3065 202.255 39.2905C202.027 39.2889 201.801 39.2379 201.593 39.1411C201.473 39.0703 201.339 39.026 201.2 39.0109C200.969 39.0109 200.733 39.2777 200.636 39.5463C200.426 40.1797 201.645 40.4712 201.813 40.528C202.245 40.5204 202.665 40.3865 203.022 40.143C203.293 39.9847 203.598 39.893 203.912 39.8753C204.166 39.8753 204.495 40.0376 204.931 40.0798C204.971 40.0718 205.008 40.0557 205.041 40.0325C205.074 40.0093 205.102 39.9795 205.123 39.945C205.152 39.8886 205.168 39.8266 205.17 39.7633C205.173 39.7 205.162 39.6368 205.137 39.5783C204.667 39.2178 204.164 38.9023 203.634 38.636C203.496 38.5654 203.175 38.4646 203.086 38.5187Z",
    fill: "url(#paint7_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.291 39.9028C218.289 40.0554 218.32 40.2067 218.383 40.3456C218.423 40.4006 218.861 40.3887 218.88 40.3034C218.918 40.1375 218.85 39.9368 218.551 39.6975C218.491 39.6517 218.28 39.8103 218.291 39.9028Z",
    fill: "url(#paint8_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.635 41.0212C192.57 41.2295 192.577 41.4535 192.655 41.6573C192.838 41.8159 193.419 41.3906 193.519 41.2586C193.555 41.2213 193.583 41.1767 193.6 41.128C193.618 41.0792 193.626 41.0272 193.622 40.9753C193.592 40.7773 193.518 40.7434 193.445 40.7434C193.165 40.8024 192.893 40.8957 192.635 41.0212Z",
    fill: "url(#paint9_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.479 38.1456C219.435 38.1458 219.393 38.1553 219.354 38.1734C219.314 38.1914 219.279 38.2176 219.251 38.2502C219.223 38.2829 219.202 38.3211 219.19 38.3625C219.177 38.4039 219.174 38.4475 219.18 38.4903C219.18 38.6974 219.319 38.8569 219.776 38.8322C220.331 38.7992 220.326 39.1017 220.568 39.1072C221.083 39.1072 220.977 38.6067 220.984 38.3821C220.991 38.1254 220.081 38.119 219.479 38.1456Z",
    fill: "url(#paint10_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.356 33.0645C216.311 33.073 216.268 33.0909 216.231 33.117C216.193 33.1431 216.161 33.1768 216.137 33.2161C216.113 33.2553 216.097 33.2991 216.091 33.3446C216.085 33.3902 216.089 33.4366 216.102 33.4807C216.168 33.565 216.444 33.455 216.8 33.6878C217.04 33.9543 217.245 34.2511 217.408 34.5706C217.487 34.6631 217.588 34.7333 217.703 34.7743C217.817 34.8153 217.94 34.8257 218.06 34.8043C218.22 34.7127 217.904 33.7493 217.804 33.7043C217.437 33.5302 217.169 33.2543 216.964 33.1543C216.769 33.0878 216.563 33.0574 216.356 33.0645Z",
    fill: "url(#paint11_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.153 36.7C218.08 36.7485 218.025 36.8197 217.997 36.9026C217.969 36.9854 217.968 37.0753 217.996 37.1583C218.227 37.3226 218.511 37.3918 218.791 37.3518C218.848 37.3224 218.892 37.2734 218.916 37.2139C218.939 37.1544 218.94 37.0884 218.919 37.0282C218.883 36.9218 218.674 36.3269 218.49 36.3269C218.367 36.3205 218.302 36.5836 218.153 36.7Z",
    fill: "url(#paint12_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.422 36.9392C197.151 37.1522 196.932 37.4252 196.785 37.7368C196.712 37.8578 196.633 38.1034 196.699 38.1034C196.766 38.114 196.836 38.1047 196.898 38.0767C196.961 38.0487 197.014 38.0033 197.051 37.9458C197.302 37.5534 197.629 37.734 197.768 37.6011C198.135 37.2546 198.135 36.8797 198.087 36.8265C197.975 36.7923 197.857 36.7846 197.741 36.8042C197.626 36.8238 197.516 36.87 197.422 36.9392Z",
    fill: "url(#paint13_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.242 30.991C214.153 31.1615 214.108 31.3517 214.112 31.5439C214.116 31.7362 214.169 31.9244 214.265 32.091C214.342 32.1616 214.617 32.0864 214.678 32.0158C214.733 31.8584 214.743 31.6887 214.708 31.5258C214.672 31.3628 214.592 31.2129 214.476 31.0928C214.398 31.0167 214.304 30.9571 214.242 30.991Z",
    fill: "url(#paint14_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.342 35.1958C215.178 35.2508 214.828 35.5698 214.904 35.7018C214.979 35.8338 215.092 35.8347 215.495 35.7797C215.663 35.7577 215.851 36.0739 215.953 36.1234C216.14 36.2035 216.337 36.258 216.539 36.2857C216.608 36.2599 216.668 36.2156 216.713 36.1577C216.758 36.0997 216.786 36.0304 216.794 35.9575C216.783 35.9034 216.455 35.6825 216.369 35.5771C216.155 35.3177 216.308 35.1563 216.235 35.0628C216.161 34.9693 215.487 35.1472 215.342 35.1958Z",
    fill: "url(#paint15_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.6 33.3083C210.591 33.3899 210.845 33.5586 210.932 33.5421C211.062 33.4895 211.195 33.446 211.331 33.4119C211.681 33.3753 212.286 33.8253 212.489 33.7639C212.552 33.7142 212.599 33.6477 212.626 33.5721C212.653 33.4965 212.657 33.4149 212.639 33.3368C212.443 33.1415 212.182 33.0232 211.906 33.0031C211.583 33.0388 211.344 32.7987 211.223 32.8564C210.735 33.0865 210.627 33.0498 210.6 33.3083Z",
    fill: "url(#paint16_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.601 30.5583C211.626 30.6436 211.725 30.7747 212.072 31.068C212.217 31.1908 212.244 31.4686 212.424 31.684C212.451 31.7161 212.748 31.805 212.759 31.7399C212.807 31.4723 212.591 31.3733 212.608 31.09C212.636 30.6427 212.632 30.5198 212.555 30.4199C212.364 30.3098 212.147 30.2522 211.926 30.2531C211.779 30.2549 211.564 30.4318 211.601 30.5583Z",
    fill: "url(#paint17_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.43 28.5252C207.39 28.7213 207.715 29.0403 207.832 29.0403C207.972 29.0403 208.291 28.7598 208.59 28.7736C208.653 28.7788 208.717 28.7695 208.776 28.7465C208.835 28.7235 208.888 28.6872 208.93 28.6406C208.973 28.594 209.005 28.5383 209.023 28.4776C209.041 28.4169 209.045 28.3529 209.034 28.2905C208.993 28.2401 208.942 28.1997 208.883 28.1724C208.824 28.1451 208.76 28.1315 208.695 28.1328C208.606 28.1911 208.501 28.2212 208.394 28.219C208.288 28.2169 208.184 28.1827 208.097 28.1209C207.903 28.01 207.532 28.0201 207.43 28.5252Z",
    fill: "url(#paint18_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75 28.4757C211.806 28.659 211.897 28.6306 211.972 28.5673C212.031 28.5105 212.1 28.4663 212.176 28.4373C212.253 28.4083 212.334 28.3952 212.416 28.3987C212.714 28.4363 213.057 29.3218 213.167 29.2906C213.244 29.2704 213.286 28.8964 213.259 28.7223C213.193 28.475 213.072 28.2457 212.906 28.0513C212.709 27.8503 212.455 27.7141 212.178 27.6608C211.928 27.6617 211.693 28.2942 211.75 28.4757Z",
    fill: "url(#paint19_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.714 30.1513C208.478 30.4868 208.246 30.5125 207.995 30.7408C207.818 30.9021 207.802 31.354 208.033 31.354C208.264 31.354 208.276 31.0918 208.908 30.8388C209.256 30.6499 209.663 30.6023 210.045 30.7059C210.083 30.7088 210.121 30.7036 210.157 30.6906C210.193 30.6776 210.226 30.6571 210.253 30.6305C210.28 30.6038 210.302 30.5717 210.316 30.5362C210.33 30.5007 210.336 30.4626 210.334 30.4245C210.089 30.2483 209.814 30.1182 209.523 30.0404C209.248 29.9845 208.963 30.0236 208.714 30.1513Z",
    fill: "url(#paint20_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.008 26.3463C207.985 26.4262 207.982 26.5104 207.997 26.592C208.013 26.6737 208.048 26.7505 208.099 26.8162C208.15 26.8818 208.216 26.9345 208.291 26.97C208.366 27.0054 208.449 27.0225 208.532 27.02C208.603 27.0281 208.675 27.017 208.74 26.9877C208.806 26.9585 208.862 26.9123 208.904 26.8539C208.945 26.7955 208.97 26.727 208.976 26.6556C208.982 26.5842 208.969 26.5125 208.938 26.448C208.862 26.2225 208.134 26.1098 208.008 26.3463Z",
    fill: "url(#paint21_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.048 26.6524C205.005 26.7817 205.016 27.0438 205.157 27.1108C205.279 27.1658 205.405 26.9137 205.693 26.9485C206.106 26.998 206.145 27.3005 206.243 27.3005C206.434 27.3005 206.642 27.0338 206.512 26.6231C206.5 26.5855 206.444 26.6231 206.31 26.5177C206.236 26.459 206.152 26.2931 206.086 26.2931C205.74 26.2903 205.158 26.3114 205.048 26.6524Z",
    fill: "url(#paint22_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.08 32.5017C203.847 32.6493 203.484 32.927 203.57 33.2533C203.6 33.3679 204.017 33.2946 204.246 33.2405C204.419 33.1971 204.571 33.0921 204.672 32.9451C204.773 32.7982 204.818 32.6193 204.796 32.4421C204.685 32.2615 204.469 32.2569 204.08 32.5017Z",
    fill: "url(#paint23_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.341 34.5917C213.157 35.0922 213.153 35.2801 213.315 35.325C213.554 35.3919 213.59 35.2828 214.111 34.6568C214.19 34.5605 214.486 34.5147 214.508 34.5064C214.565 34.4689 214.613 34.4197 214.649 34.3621C214.685 34.3046 214.708 34.24 214.717 34.1728C214.706 34.0747 214.178 33.8318 214.056 33.8464C213.881 33.8648 213.37 34.5092 213.341 34.5917Z",
    fill: "url(#paint24_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.808 30.1303C205.422 30.6564 205.455 31.3091 205.701 31.3274C205.803 31.3348 205.895 31.1358 205.914 31.0524C205.908 30.9122 205.939 30.7729 206.005 30.6491C206.036 30.6057 206.078 30.571 206.126 30.5483C206.174 30.5257 206.227 30.5159 206.28 30.5198C206.32 30.5198 206.42 30.0615 206.241 29.9625C206.062 29.8635 205.95 29.9378 205.808 30.1303Z",
    fill: "url(#paint25_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.607 34.4285C198.467 34.5575 198.373 34.7283 198.339 34.9152C198.326 35.0876 198.5 35.2819 198.837 35.1902C199.075 35.1242 199.239 34.9152 199.673 34.6971C199.889 34.5898 199.901 34.3304 199.797 34.3084L199.272 34.1892C199.03 34.1954 198.797 34.2793 198.607 34.4285Z",
    fill: "url(#paint26_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.437 28.1622C202.248 28.2236 202.053 28.263 201.856 28.2795C201.723 28.3212 201.603 28.3988 201.511 28.5037C201.419 28.6087 201.358 28.7369 201.334 28.8744C201.367 29.3461 201.481 29.8086 201.67 30.2421C201.716 30.269 201.769 30.2844 201.822 30.2869C201.876 30.2895 201.93 30.2791 201.979 30.2568C202.085 30.1807 201.847 29.165 202.05 28.9248C202.222 28.7195 203.27 28.4729 203.367 28.3079C203.432 28.197 203.342 27.6663 203.26 27.6571C203.103 27.6388 202.637 28.0513 202.437 28.1622Z",
    fill: "url(#paint27_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.642 33.543C196.483 33.6238 196.336 33.7269 196.206 33.8492C196.148 33.9083 196.106 33.9819 196.086 34.0626C196.066 34.1432 196.067 34.2278 196.091 34.3075C196.132 34.4322 196.223 34.467 196.372 34.3552C196.511 34.2028 196.703 34.1101 196.908 34.0967C197.006 34.0774 197.034 33.7786 196.951 33.6493C196.915 33.6037 196.867 33.5695 196.812 33.5506C196.757 33.5318 196.698 33.5291 196.642 33.543Z",
    fill: "url(#paint28_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.748 36.9888C200.794 37.0053 201.18 37.3554 201.023 37.5323C200.949 37.591 200.87 37.5498 200.565 37.624C200.336 37.6898 200.131 37.8203 199.974 37.9998C199.781 38.189 199.545 38.3292 199.287 38.4087C199.253 38.4095 199.219 38.4034 199.188 38.3906C199.156 38.3778 199.128 38.3587 199.104 38.3344C199.066 38.2781 199.039 38.2145 199.027 38.1477C199.014 38.0809 199.015 38.0122 199.03 37.9458C199.046 37.8642 199.14 37.6093 199.262 37.5901C199.511 37.5746 199.752 37.4998 199.965 37.3719C200.263 37.2051 200.271 36.9356 200.748 36.9888Z",
    fill: "url(#paint29_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.039 32.4073C198.934 32.4955 198.868 32.6217 198.855 32.7583C198.855 32.9224 199.108 33.1956 199.303 33.0132C199.606 32.7308 199.787 32.2413 199.635 32.1616C199.482 32.0818 199.163 32.2743 199.039 32.4073Z",
    fill: "url(#paint30_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.749 31.75C201.521 31.787 201.305 31.8801 201.121 32.021C200.937 32.162 200.791 32.3463 200.696 32.5576C200.682 32.6266 200.696 32.6982 200.733 32.7577C200.771 32.8172 200.83 32.8601 200.898 32.8775C201.072 32.8775 201.415 32.3458 201.631 32.2844C201.86 32.2684 202.09 32.309 202.299 32.4027C202.606 32.4998 202.698 32.5713 202.758 32.4164C202.817 32.2615 202.729 31.8618 202.574 31.8142C202.308 31.7302 202.026 31.7082 201.749 31.75Z",
    fill: "url(#paint31_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.493 42.4649C195.465 42.7097 195.597 42.8628 196.093 42.8912C196.625 42.9214 196.591 42.5978 196.536 42.5722C196.274 42.4773 196.036 42.3254 195.84 42.1276C195.809 42.0983 195.527 42.1698 195.493 42.4649Z",
    fill: "url(#paint32_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.148 39.9175C195.131 40.033 195.15 40.1508 195.201 40.2558C195.251 40.3104 195.314 40.3525 195.384 40.3786C195.481 40.4079 195.577 40.3786 195.856 40.1568C195.97 40.0651 196.088 40.0697 196.174 39.9798C196.195 39.9509 196.208 39.9175 196.213 39.8824C196.218 39.8474 196.214 39.8116 196.203 39.7782C196.113 39.6249 195.966 39.513 195.795 39.4665C195.535 39.5414 195.308 39.6999 195.148 39.9175Z",
    fill: "url(#paint33_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.556 35.4827C196.345 35.4775 196.137 35.5301 195.953 35.6348C195.848 35.6892 195.76 35.7732 195.702 35.8766C195.643 35.9801 195.616 36.0984 195.624 36.2169C195.629 36.2834 195.654 36.3467 195.697 36.3984C195.739 36.45 195.796 36.4875 195.86 36.5057C195.931 36.5168 196.005 36.5051 196.069 36.4722C196.134 36.4393 196.187 36.3868 196.22 36.3223C196.244 36.2193 196.303 36.1276 196.386 36.0622C196.47 35.9968 196.572 35.9615 196.678 35.9621C196.871 35.9401 197.01 35.9621 197.082 35.8475C197.153 35.7329 197.127 35.534 197.082 35.5221C196.909 35.4835 196.732 35.4702 196.556 35.4827Z",
    fill: "url(#paint34_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.701 42.1129C198.692 42.3283 198.819 42.4796 198.942 42.4796C199.066 42.4796 199.283 42.3778 199.415 42.3668C199.635 42.3494 199.726 42.4292 199.75 42.3787C199.771 42.3176 199.777 42.2523 199.767 42.1884C199.757 42.1246 199.732 42.0641 199.693 42.0121C199.621 41.8544 199.418 41.936 199.327 41.9378C199.143 41.9378 198.983 41.782 198.91 41.782C198.772 41.7747 198.705 42.0304 198.701 42.1129Z",
    fill: "url(#paint35_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.26 41.6738C212.376 41.7875 212.52 41.868 212.678 41.907C212.836 41.9461 213.001 41.9421 213.156 41.8957C213.268 41.8682 213.368 41.5785 213.238 41.5006C213.111 41.4188 212.967 41.365 212.818 41.3425C212.668 41.3201 212.516 41.3296 212.37 41.3704C212.341 41.3805 212.314 41.3969 212.292 41.4186C212.27 41.4403 212.253 41.4667 212.242 41.4958C212.232 41.5249 212.228 41.556 212.231 41.5868C212.234 41.6176 212.244 41.6474 212.26 41.6738Z",
    fill: "url(#paint36_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.147 40.7938C196.872 40.8791 196.743 40.9579 196.708 41.1779C196.682 41.3356 196.832 41.3805 197.094 41.3878C197.514 41.4007 197.716 41.177 197.716 40.9882C197.716 40.6545 197.392 40.7187 197.147 40.7938Z",
    fill: "url(#paint37_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.661 42.1083C214.796 42.3457 215.161 42.1257 215.594 42.2733C215.726 42.3182 215.907 42.6583 216.123 42.6024C216.233 42.574 216.352 42.1542 216.358 41.8828C216.358 41.683 215.974 41.5803 215.808 41.6381C215.491 41.7591 215.16 41.8428 214.824 41.8874C214.778 41.9042 214.738 41.9341 214.709 41.9734C214.68 42.0127 214.664 42.0596 214.661 42.1083Z",
    fill: "url(#paint38_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.146 39.736C215.176 39.8414 215.83 39.7681 216.062 39.9331C216.393 40.1668 216.692 40.1971 216.73 40.1228C216.778 40.0123 216.785 39.8889 216.752 39.7734C216.718 39.658 216.646 39.5576 216.547 39.4894C216.349 39.3569 216.119 39.2783 215.882 39.2612C215.195 39.3134 215.116 39.6333 215.146 39.736Z",
    fill: "url(#paint39_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.433 41.6298C219.292 41.6298 219.104 41.9892 218.808 41.9745C218.638 41.9672 218.368 41.8196 218.244 41.8251C218.034 41.8343 217.8 42.2293 217.858 42.3329C218 42.4521 218.164 42.5421 218.34 42.5978C218.517 42.6535 218.703 42.6737 218.887 42.6574C218.972 42.6664 219.058 42.6507 219.134 42.6122C219.21 42.5736 219.273 42.5139 219.315 42.4402C219.456 42.2312 219.708 42.1945 219.766 42.1377C219.798 42.0382 219.801 41.9318 219.776 41.8306C219.737 41.7735 219.686 41.7259 219.627 41.6911C219.568 41.6564 219.501 41.6354 219.433 41.6298Z",
    fill: "url(#paint40_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.505 41.9763C221.475 42.0203 221.455 42.0712 221.449 42.1244C221.443 42.1776 221.449 42.2315 221.469 42.2815C221.488 42.3315 221.52 42.3759 221.56 42.4109C221.601 42.446 221.649 42.4705 221.701 42.4823C221.801 42.4988 222.311 42.3953 222.349 42.299C222.394 42.1789 222.249 41.8627 222.097 41.8407C221.946 41.8187 221.603 41.8333 221.505 41.9763Z",
    fill: "url(#paint41_radial_2690_4771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.739 39.3583L209.623 39.2575C209.376 39.4622 209.195 39.7351 209.102 40.0422L209.256 40.0614C209.343 39.7838 209.511 39.5388 209.739 39.3583Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.103 40.0394C209.096 40.0813 209.096 40.124 209.103 40.1659C209.114 40.2475 209.202 40.3098 209.334 40.3493L209.399 40.2072C209.346 40.1973 209.296 40.1729 209.256 40.1366C209.252 40.1111 209.252 40.0851 209.256 40.0596L209.103 40.0394Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.995 40.275C209.793 40.2806 209.591 40.2578 209.395 40.2072L209.325 40.3474C209.543 40.4083 209.769 40.4361 209.995 40.4299C210.346 40.4475 210.698 40.3848 211.021 40.2466L210.898 40.1393C210.608 40.2394 210.301 40.2854 209.995 40.275ZM201.713 30.2283L201.595 30.3301C201.662 30.3753 201.74 30.4021 201.82 30.4077C201.901 30.4133 201.981 30.3976 202.054 30.3622L201.947 30.2439C201.869 30.2608 201.788 30.2554 201.713 30.2283Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 29.5161C201.969 29.7575 201.971 30.002 201.944 30.2439L202.044 30.3658C202.058 30.3569 202.068 30.345 202.076 30.331C202.128 30.1134 202.138 29.8876 202.103 29.6664C202.091 29.4125 202.031 29.099 202.156 28.9927L202.056 28.8744C201.896 29.0101 201.917 29.2677 201.937 29.5161Z",
    fill: "#EFA952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.499 42.2669L221.349 42.3018C221.368 42.3569 221.397 42.4076 221.436 42.4511C221.475 42.4945 221.522 42.5298 221.575 42.5548L221.66 42.4246C221.588 42.3946 221.531 42.3382 221.499 42.2669Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.194 27.6983C212.395 27.7417 212.583 27.8311 212.744 27.9596L212.824 27.8258C212.639 27.6803 212.422 27.5833 212.19 27.5434C212.098 27.5561 212.01 27.5932 211.937 27.6511C211.863 27.709 211.807 27.7854 211.773 27.8725L211.909 27.9477C211.933 27.9083 212.046 27.6965 212.194 27.6983ZM196.556 33.6099C196.59 33.5825 196.631 33.565 196.675 33.5592C196.718 33.5534 196.763 33.5595 196.803 33.5769L196.855 33.4321C196.79 33.4057 196.72 33.3969 196.651 33.4068C196.581 33.4166 196.516 33.4446 196.461 33.488L196.25 33.6393L196.349 33.7603L196.556 33.6099Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.236 30.5968C210.205 30.6379 210.161 30.6663 210.11 30.6766L210.127 30.8297C210.199 30.8207 210.266 30.7886 210.318 30.738L210.236 30.5968Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.533 40.4088L201.479 40.5555L201.792 40.6609L201.842 40.5152L201.533 40.4088Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.494 28.318C203.509 28.2333 203.511 28.1468 203.502 28.0613L203.349 28.0714C203.358 28.1377 203.358 28.2049 203.349 28.2712C203.341 28.2978 203.325 28.3208 203.302 28.3363L203.431 28.428C203.459 28.3963 203.481 28.3588 203.494 28.318Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.312 30.1468C206.322 30.213 206.322 30.2803 206.312 30.3466L206.464 30.3778C206.483 30.2776 206.483 30.1745 206.464 30.0743L206.312 30.1468Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9 30.9525C205.9 31.1358 205.771 31.3027 205.702 31.3027L205.725 31.4558C205.897 31.4347 206.036 31.2037 206.047 31.0524C206.039 30.9413 206.062 30.8302 206.112 30.7307L206.057 30.5638C206.003 30.6124 205.96 30.6726 205.933 30.74C205.906 30.8074 205.895 30.8801 205.9 30.9525ZM218.974 37.3417L218.853 37.25C218.838 37.2773 218.815 37.2996 218.787 37.3142L218.841 37.459C218.896 37.435 218.943 37.3939 218.974 37.3417Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.677 26.2931L208.725 26.1464C208.542 26.0914 208.105 25.9998 207.914 26.2546L208.033 26.3527C208.135 26.1849 208.509 26.239 208.677 26.2931Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.916 26.4645C208.928 26.5046 208.935 26.5463 208.936 26.5883L209.09 26.6313C209.094 26.5585 209.084 26.4855 209.063 26.4159C209.031 26.348 208.984 26.2882 208.926 26.2415C208.867 26.1947 208.798 26.1622 208.725 26.1464L208.671 26.2913C208.722 26.3006 208.77 26.3209 208.813 26.3508C208.855 26.3808 208.89 26.4195 208.916 26.4645Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.291 26.9274L208.234 27.0713C208.725 27.2895 209.076 27.0227 209.09 26.6313L208.936 26.5837C208.95 26.8917 208.712 27.1126 208.291 26.9274Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.015 26.6167L207.864 26.6497C207.893 26.7411 207.94 26.8256 208.004 26.8977C208.067 26.9699 208.144 27.028 208.231 27.0686L208.293 26.9274C208.229 26.8968 208.171 26.8535 208.123 26.8002C208.075 26.7468 208.038 26.6844 208.015 26.6167Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.037 26.3472L207.914 26.2555C207.877 26.314 207.853 26.3801 207.844 26.4489C207.836 26.5177 207.843 26.5875 207.864 26.6533L208.017 26.6258C208 26.5807 207.993 26.5324 207.996 26.4843C208 26.4362 208.014 26.3894 208.037 26.3472ZM206.163 26.3793C206.236 26.5004 206.353 26.5883 206.489 26.624C206.527 26.7041 206.539 26.7934 206.526 26.8807L206.677 26.9201C206.697 26.7056 206.65 26.4764 206.51 26.4709C206.408 26.4709 206.298 26.2931 206.235 26.228C206.218 26.2109 206.199 26.1966 206.178 26.1858L206.103 26.3215C206.119 26.3233 206.134 26.3417 206.163 26.3793Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.106 26.3215L206.186 26.1886C205.812 26.1287 205.428 26.1931 205.093 26.3719L205.21 26.4755C205.491 26.3505 205.799 26.2976 206.106 26.3215Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.526 26.8807C206.524 26.9655 206.504 27.049 206.467 27.1254C206.442 27.1629 206.409 27.1948 206.371 27.2192C206.333 27.2436 206.29 27.2601 206.246 27.2675C206.211 27.2593 206.126 27.1144 206.026 27.0457C205.912 26.9676 205.778 26.9252 205.641 26.9238V27.0787C205.748 27.0783 205.854 27.1102 205.943 27.1703C206.035 27.2336 206.107 27.3931 206.218 27.4151C206.288 27.4182 206.358 27.4037 206.421 27.373C206.484 27.3422 206.538 27.2962 206.578 27.2391C206.644 27.1424 206.681 27.0288 206.684 26.9118L206.526 26.8807Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.338 27.02L205.39 27.1713C205.46 27.1113 205.549 27.0787 205.641 27.0796V26.9238C205.532 26.9213 205.425 26.9552 205.338 27.02Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.195 27.0952C205.185 27.0946 205.176 27.0928 205.167 27.0897L205.114 27.2354C205.141 27.2444 205.17 27.2493 205.199 27.2501C205.273 27.2443 205.343 27.2154 205.4 27.1676L205.342 27.02C205.258 27.075 205.226 27.0952 205.195 27.0952Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.892 26.7533C204.883 26.9439 204.949 27.1841 205.111 27.2363L205.159 27.0897C205.068 27.053 205.039 26.8385 205.046 26.7606L204.892 26.7533Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21 26.4783L205.099 26.371C205.038 26.4157 204.987 26.4738 204.952 26.5408C204.917 26.6078 204.897 26.6821 204.894 26.7578H205.049C205.052 26.7019 205.068 26.6473 205.096 26.5987C205.124 26.5501 205.163 26.5088 205.21 26.4783Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.079 28.1438C208.17 28.2067 208.278 28.2416 208.388 28.2444C208.499 28.2472 208.608 28.2176 208.702 28.1594C208.763 28.1505 208.826 28.1631 208.878 28.1952L208.955 28.0604C208.906 28.031 208.851 28.0126 208.795 28.0064C208.738 28.0002 208.68 28.0065 208.626 28.0247C208.56 28.0692 208.481 28.0929 208.401 28.0929C208.321 28.0929 208.243 28.0692 208.176 28.0247C208.057 27.9526 207.916 27.9282 207.78 27.9562C207.644 27.9843 207.523 28.0628 207.443 28.1759L207.577 28.252C207.634 28.1778 207.716 28.1263 207.808 28.1065C207.9 28.0867 207.996 28.0999 208.079 28.1438Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.017 28.3116C209.017 28.3501 209.007 28.384 209.002 28.4152L209.154 28.4418L209.171 28.3208C209.179 28.2236 209.074 28.1209 208.949 28.0586L208.876 28.1952C208.934 28.2187 208.983 28.2594 209.017 28.3116Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.408 28.9285C208.524 28.8918 208.647 28.9129 208.765 28.8845C208.87 28.8637 208.966 28.8085 209.037 28.7276C209.108 28.6467 209.15 28.5446 209.157 28.4372L209.004 28.4152C208.953 28.6792 208.81 28.7177 208.729 28.7342C208.606 28.7404 208.483 28.7564 208.362 28.7818C208.195 28.8674 208.024 28.9445 207.85 29.0128C207.79 29.0128 207.758 28.9826 207.69 28.9212L207.584 29.0339C207.648 29.1091 207.739 29.1564 207.838 29.1659C207.996 29.1723 208.231 28.9835 208.408 28.9285Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.458 28.5728H207.302C207.338 28.7576 207.438 28.9236 207.586 29.0403L207.687 28.923C207.575 28.8342 207.495 28.7113 207.458 28.5728Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.577 28.2511L207.445 28.1704C207.36 28.2897 207.31 28.4309 207.302 28.5774H207.457C207.466 28.4598 207.508 28.3468 207.577 28.2511ZM212.846 28.043C213.03 28.2355 213.164 28.4699 213.237 28.7259C213.243 28.7641 213.246 28.8028 213.243 28.8414L213.396 28.8717C213.4 28.8123 213.397 28.7527 213.388 28.6938C213.309 28.4074 213.16 28.1453 212.954 27.9312C212.913 27.8924 212.869 27.8563 212.824 27.823L212.747 27.9596C212.782 27.9854 212.815 28.0133 212.846 28.043Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.243 28.8414C213.237 28.9874 213.211 29.1319 213.167 29.2713L213.228 29.4437C213.315 29.4244 213.385 29.0944 213.396 28.8671L213.243 28.8414Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.167 29.275C213.06 29.1525 212.967 29.0174 212.892 28.8726C212.756 28.6333 212.617 28.3932 212.434 28.3776L212.422 28.5307C212.556 28.5518 212.707 28.8561 212.827 29.0605C213.059 29.4547 213.174 29.4648 213.239 29.4455L213.167 29.275Z",
    fill: "#FFC378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.351 28.3675C212.093 28.3675 211.95 28.5738 211.904 28.5793H211.855L211.808 28.7241C211.841 28.7326 211.875 28.7372 211.909 28.7378C212.066 28.7287 212.122 28.5252 212.351 28.5252C212.374 28.5249 212.397 28.5271 212.42 28.5316L212.428 28.3776C212.402 28.3725 212.376 28.3691 212.351 28.3675Z",
    fill: "#EFA952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.812 28.725L211.855 28.5783C211.812 28.571 211.805 28.5518 211.778 28.4674C211.777 28.2863 211.824 28.1082 211.912 27.9504L211.78 27.8707C211.666 28.0646 211.614 28.2883 211.63 28.5123C211.668 28.6278 211.702 28.6957 211.812 28.725Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.851 30.133C211.768 30.1509 211.692 30.1908 211.63 30.2485L211.73 30.3658C211.769 30.3281 211.818 30.3007 211.87 30.2861C212.041 30.2755 212.211 30.2972 212.373 30.3503L212.416 30.2018C212.234 30.143 212.042 30.1197 211.851 30.133Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.735 31.1138C212.735 30.8113 212.812 30.6445 212.684 30.3805C212.62 30.2903 212.524 30.2275 212.416 30.2045L212.367 30.3512C212.429 30.365 212.487 30.3932 212.536 30.4337C212.654 30.5996 212.579 30.8847 212.581 31.1166C212.59 31.2565 212.634 31.3918 212.71 31.5098C212.725 31.5476 212.734 31.5875 212.736 31.6281L212.893 31.6611C212.894 31.5809 212.876 31.5017 212.842 31.4292C212.781 31.3344 212.744 31.2261 212.735 31.1138Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.432 31.6638L212.356 31.7977C212.476 31.8627 212.612 31.8944 212.748 31.8893C212.882 31.8802 212.893 31.783 212.893 31.6565L212.736 31.6281C212.74 31.6637 212.74 31.6997 212.736 31.7353C212.63 31.7377 212.526 31.7131 212.432 31.6638Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.243 31.2779C212.16 31.1104 212.034 30.9685 211.877 30.8673L211.776 30.9855C211.923 31.0776 212.04 31.2112 212.112 31.3696C212.178 31.5236 212.255 31.7491 212.357 31.8004L212.429 31.6638C212.352 31.5427 212.29 31.4132 212.243 31.2779Z",
    fill: "#EFA952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.685 30.6445L211.565 30.7435C211.631 30.8324 211.706 30.9153 211.787 30.991L211.879 30.8673C211.808 30.7982 211.744 30.7237 211.685 30.6445Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.621 30.551C211.611 30.5253 211.643 30.4392 211.736 30.3613L211.63 30.2485C211.574 30.2872 211.53 30.3409 211.502 30.4034C211.475 30.4659 211.466 30.5348 211.475 30.6023C211.499 30.6549 211.53 30.7041 211.567 30.749L211.681 30.6445C211.658 30.6152 211.638 30.5839 211.621 30.551Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.253 31.0075C214.291 31.0096 214.329 31.0197 214.364 31.0372C214.399 31.0547 214.43 31.0792 214.454 31.1093L214.565 31.002C214.521 30.9479 214.463 30.9065 214.398 30.882C214.333 30.8575 214.262 30.8508 214.193 30.8627C214.133 30.8819 214.069 30.9965 214.028 31.1377L214.169 31.2055C214.186 31.1355 214.214 31.0686 214.253 31.0075Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.712 31.75L214.867 31.7793C214.87 31.6352 214.845 31.4919 214.792 31.3576C214.74 31.2234 214.661 31.1009 214.561 30.9974L214.454 31.1102C214.621 31.2813 214.714 31.5112 214.712 31.75Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.632 32.0168C214.527 32.0775 214.403 32.0971 214.285 32.0717L214.2 32.2019C214.288 32.2321 214.381 32.2418 214.473 32.2303C214.565 32.2189 214.654 32.1866 214.731 32.1359C214.78 32.0898 214.817 32.0332 214.841 31.9705C214.864 31.9078 214.873 31.8405 214.867 31.7738L214.712 31.75C214.715 31.8628 214.7 31.9764 214.632 32.0168Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.204 32.2083L214.283 32.0745C214.204 32.0158 214.127 31.7995 214.142 31.3467C214.145 31.3004 214.154 31.2546 214.167 31.2101L214.028 31.1377C214.006 31.204 213.993 31.2726 213.987 31.3421C213.979 31.6638 214.008 32.0754 214.204 32.2083Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.279 29.8873C209.054 29.8847 208.833 29.942 208.637 30.0533C208.554 30.1589 208.459 30.2543 208.353 30.3374L208.194 30.4337L208.28 30.5629L208.436 30.4713C208.555 30.3795 208.663 30.2739 208.757 30.1568C208.923 30.0853 209.102 30.0476 209.282 30.0459C209.51 30.0558 209.732 30.1159 209.933 30.2219L209.991 30.0798C209.772 29.9617 209.528 29.8958 209.279 29.8873Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.465 30.4217C210.475 30.3182 210.225 30.1788 209.983 30.0743L209.93 30.2183C210.065 30.2726 210.192 30.3458 210.307 30.4355C210.303 30.4564 210.297 30.477 210.29 30.4969L210.432 30.562C210.448 30.5167 210.459 30.4696 210.465 30.4217Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.433 30.5583L210.29 30.4978C210.278 30.5339 210.259 30.5677 210.236 30.5978L210.313 30.7408C210.367 30.6901 210.408 30.6277 210.433 30.5583ZM210.036 30.6729C209.682 30.5983 209.313 30.6318 208.978 30.7692C208.953 30.7848 208.924 30.7985 208.897 30.8132L208.95 30.9598L209.057 30.9021C209.356 30.7847 209.684 30.757 209.998 30.8223C210.042 30.833 210.088 30.8352 210.132 30.8288L210.11 30.6766C210.086 30.6799 210.06 30.6787 210.036 30.6729Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.289 31.1707C208.224 31.2517 208.132 31.3069 208.03 31.3265C208.011 31.3263 207.992 31.3199 207.976 31.3082L207.893 31.4393C207.933 31.4668 207.981 31.4815 208.03 31.4814C208.174 31.4649 208.306 31.3921 208.397 31.2788C208.565 31.1441 208.752 31.0359 208.952 30.958L208.895 30.8132C208.674 30.897 208.469 31.0179 208.289 31.1707Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.74 31.0249C207.727 31.1027 207.735 31.1826 207.763 31.2562C207.791 31.3299 207.838 31.3947 207.9 31.4438L207.976 31.3082C207.943 31.2746 207.919 31.2339 207.904 31.1892C207.89 31.1445 207.886 31.097 207.893 31.0506L207.74 31.0249Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 30.5629L208.195 30.4309C207.802 30.6491 207.76 30.8581 207.737 31.0295L207.891 31.0506C207.899 30.9571 207.906 30.7673 208.276 30.5629Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.907 30.0505C205.937 30.0076 205.98 29.9755 206.03 29.9589C206.079 29.9424 206.133 29.9424 206.182 29.9588L206.251 29.8204C206.171 29.7884 206.083 29.7837 206 29.8071C205.917 29.8305 205.844 29.8806 205.793 29.9497L205.625 30.1678L205.754 30.2531C205.796 30.1917 205.907 30.0505 205.907 30.0505Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.242 29.825L206.178 29.9652C206.216 29.9788 206.249 30.0035 206.273 30.0362C206.297 30.0689 206.311 30.108 206.313 30.1486L206.456 30.0807C206.447 30.0227 206.422 29.9682 206.384 29.9231C206.347 29.878 206.298 29.8441 206.242 29.825Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46 30.375L206.308 30.3484C206.301 30.3999 206.286 30.4501 206.266 30.4978L206.339 30.6436C206.403 30.6124 206.444 30.4768 206.46 30.375Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.267 30.496C206.239 30.4943 206.211 30.4962 206.184 30.5015L206.156 30.6848C206.175 30.6707 206.198 30.6609 206.222 30.6561C206.245 30.6514 206.27 30.6518 206.293 30.6573C206.311 30.6576 206.329 30.6528 206.345 30.6436L206.267 30.496Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.16 30.6757L206.183 30.5015C206.135 30.5095 206.091 30.5311 206.055 30.5638L206.107 30.7362C206.121 30.7128 206.139 30.6923 206.16 30.6757Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.633 31.2651L205.556 31.4035C205.58 31.4233 205.608 31.4381 205.637 31.4469C205.667 31.4558 205.698 31.4584 205.729 31.4548L205.7 31.3027C205.674 31.2981 205.651 31.2848 205.633 31.2651Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.561 31.4072L205.632 31.2651C205.58 31.2085 205.55 31.1356 205.546 31.0588L205.393 31.09C205.397 31.1516 205.415 31.2117 205.443 31.2663C205.472 31.3209 205.512 31.3689 205.561 31.4072Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.707 30.3246C205.719 30.3008 205.733 30.2782 205.749 30.2568L205.623 30.1651C205.602 30.1939 205.583 30.2246 205.566 30.2568C205.439 30.5162 205.38 30.8034 205.394 31.0918L205.547 31.0561C205.541 30.803 205.595 30.5521 205.707 30.3246Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.277 27.5333C202.989 27.5333 202.608 27.9513 202.366 28.0632C202.193 28.1068 202.016 28.1375 201.838 28.1548C201.741 28.1788 201.65 28.2217 201.569 28.2812C201.489 28.3406 201.421 28.4155 201.37 28.5013L201.498 28.5857C201.58 28.4501 201.712 28.3515 201.865 28.3107C202.057 28.2932 202.247 28.2583 202.433 28.2062C202.639 28.1209 203.053 27.7057 203.258 27.691L203.331 27.5498C203.315 27.5388 203.296 27.533 203.277 27.5333Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.328 27.5434L203.26 27.6873C203.315 27.8083 203.346 27.9387 203.352 28.0714L203.506 28.0659C203.488 27.8542 203.433 27.5975 203.328 27.5434Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.432 28.4243L203.299 28.3327C203.081 28.4352 202.857 28.5249 202.628 28.6013L202.719 28.7333C202.969 28.6621 203.209 28.5583 203.432 28.4243Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.056 28.8744L202.148 28.9963C202.324 28.8815 202.516 28.7934 202.718 28.7351L202.627 28.6049C202.424 28.6649 202.231 28.7558 202.056 28.8744Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.592 29.9478L201.494 29.605C201.417 29.3862 201.372 29.1569 201.362 28.9248L201.208 28.89C201.217 29.1777 201.271 29.4623 201.371 29.7324L201.441 29.9845C201.47 30.1108 201.524 30.23 201.6 30.3347L201.714 30.2283C201.656 30.1433 201.614 30.0481 201.592 29.9478Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.366 28.8717C201.391 28.7687 201.436 28.6716 201.498 28.5857L201.374 28.494C201.298 28.5996 201.243 28.7192 201.213 28.846C201.21 28.8621 201.208 28.8783 201.208 28.8946L201.362 28.9248C201.362 28.907 201.364 28.8893 201.366 28.8717Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.557 32.3385C204.579 32.3387 204.601 32.3411 204.623 32.3458L204.674 32.2001C204.636 32.1892 204.596 32.1836 204.557 32.1836C204.279 32.2485 204.018 32.3706 203.79 32.542L203.882 32.6685C204.081 32.5115 204.311 32.399 204.557 32.3385Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 32.4503C204.788 32.5378 204.781 32.6272 204.754 32.7116L204.9 32.762C204.946 32.6341 204.946 32.4939 204.9 32.366C204.845 32.2856 204.763 32.2269 204.669 32.2001L204.614 32.3449C204.679 32.3587 204.736 32.3963 204.774 32.4503Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.902 32.7583L204.754 32.7125C204.724 32.8347 204.662 32.9464 204.573 33.0353C204.484 33.1242 204.372 33.1869 204.25 33.2167L204.31 33.3606C204.453 33.3215 204.583 33.2451 204.687 33.1393C204.791 33.0335 204.865 32.9021 204.902 32.7583Z",
    fill: "#F8A943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.234 33.2167C204.084 33.2561 203.93 33.2794 203.775 33.2863C203.692 33.2863 203.607 33.2717 203.592 33.2396L203.492 33.3624C203.572 33.4218 203.672 33.4498 203.772 33.4413C203.954 33.4336 204.135 33.405 204.311 33.356L204.25 33.2167H204.234Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 33.3679L203.589 33.2405C203.572 33.1469 203.586 33.0501 203.629 32.9655L203.477 32.9261C203.425 33.0333 203.393 33.2891 203.497 33.3679Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.883 32.6667L203.792 32.5438C203.657 32.6452 203.55 32.7781 203.479 32.9307L203.633 32.9655C203.694 32.8489 203.779 32.747 203.883 32.6667Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92 32.036L201.025 32.1497C201.199 31.9863 201.41 31.8683 201.64 31.8063C201.87 31.7442 202.112 31.74 202.344 31.794L202.381 31.6428C202.124 31.5835 201.856 31.5884 201.601 31.657C201.346 31.7256 201.112 31.8557 200.92 32.036Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.586 31.6923C202.519 31.6705 202.451 31.654 202.381 31.6428L202.341 31.7931C202.407 31.803 202.473 31.8184 202.538 31.8389C202.579 31.8594 202.616 31.8889 202.644 31.9252C202.673 31.9615 202.693 32.0037 202.704 32.0488L202.851 32.0012C202.834 31.9328 202.801 31.8693 202.755 31.8157C202.709 31.7621 202.651 31.7199 202.586 31.6923Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.704 32.0488C202.731 32.1314 202.743 32.2186 202.738 32.3055L202.89 32.3468C202.902 32.2282 202.888 32.1084 202.849 31.9957L202.704 32.0488Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89 32.3422L202.737 32.3055C202.738 32.3653 202.72 32.4237 202.685 32.4723L202.751 32.6126C202.794 32.582 202.829 32.5414 202.854 32.4943C202.878 32.4472 202.89 32.395 202.89 32.3422Z",
    fill: "#F8A943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.685 32.4723H202.68C202.515 32.4723 202.057 32.2698 201.886 32.2505L201.874 32.4054C202.137 32.4977 202.407 32.5715 202.681 32.6263C202.707 32.6263 202.733 32.6197 202.756 32.6071L202.685 32.4723Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.516 32.3082L201.579 32.4512C201.623 32.4233 201.672 32.4051 201.724 32.3978C201.776 32.3905 201.828 32.3944 201.879 32.4091L201.886 32.2532C201.76 32.2243 201.628 32.2439 201.516 32.3082Z",
    fill: "#F8A943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.516 32.3083C201.395 32.3899 201.289 32.4909 201.201 32.6071C201.049 32.7739 200.955 32.8445 200.898 32.8445V32.9994C201.054 32.9994 201.224 32.8161 201.304 32.729C201.386 32.6229 201.481 32.5283 201.588 32.4476L201.516 32.3083Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.821 32.8023L200.722 32.9206C200.771 32.9647 200.832 32.9922 200.898 32.9994V32.8445H200.889C200.864 32.833 200.842 32.8189 200.821 32.8023Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.726 32.9243L200.818 32.8023C200.782 32.7764 200.754 32.7412 200.736 32.7006L200.591 32.7538C200.619 32.8221 200.666 32.8811 200.726 32.9243Z",
    fill: "#EFA952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.571 32.6346C200.571 32.677 200.579 32.719 200.595 32.7583L200.739 32.7006C200.731 32.6797 200.726 32.6572 200.726 32.6346C200.742 32.5369 200.776 32.4432 200.828 32.3591C200.881 32.275 200.949 32.2022 201.03 32.1451L200.92 32.036C200.824 32.1066 200.743 32.1962 200.683 32.2991C200.624 32.4021 200.585 32.5163 200.571 32.6346Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.558 32.1781C199.577 32.1761 199.597 32.1806 199.614 32.1909L199.667 32.0433C199.633 32.0291 199.597 32.0222 199.56 32.0232C199.295 32.0527 199.052 32.1842 198.883 32.3898L199 32.4907C199.14 32.3205 199.339 32.2089 199.558 32.1781Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.667 32.0433L199.612 32.1882C199.675 32.2157 199.657 32.3284 199.647 32.3843L199.807 32.3614C199.824 32.3004 199.819 32.2354 199.793 32.1774C199.768 32.1195 199.723 32.0721 199.667 32.0433Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.646 32.3798C199.621 32.4875 199.58 32.591 199.525 32.6868L199.66 32.7602C199.732 32.6369 199.78 32.5018 199.804 32.3614L199.646 32.3798Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.312 32.971C199.263 33.0161 199.201 33.0452 199.135 33.0544C199.09 33.0365 199.048 33.0118 199.011 32.9811L198.908 33.0966C198.965 33.1442 199.031 33.1811 199.101 33.2057C199.216 33.2089 199.328 33.1668 199.413 33.0883C199.515 32.9927 199.6 32.8813 199.667 32.7583L199.528 32.6896C199.471 32.7941 199.398 32.8891 199.312 32.971Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.888 32.8005L198.737 32.8344C198.764 32.9403 198.826 33.0339 198.913 33.1003L199.011 32.9811C198.951 32.9363 198.908 32.8728 198.888 32.8005Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.882 32.7583C198.889 32.6556 198.931 32.5584 199.001 32.4833L198.88 32.3917C198.787 32.4948 198.733 32.6276 198.728 32.7666C198.728 32.7929 198.731 32.8191 198.738 32.8445L198.887 32.806C198.883 32.7905 198.882 32.7744 198.882 32.7583ZM196.855 33.4321L196.799 33.576C196.842 33.5871 196.88 33.6104 196.909 33.643C196.938 33.6756 196.957 33.716 196.963 33.7593L197.108 33.7007C197.093 33.638 197.061 33.5803 197.017 33.5333C196.973 33.4862 196.917 33.4514 196.855 33.4321Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.962 33.7502C196.976 33.8151 196.976 33.8823 196.962 33.9473L197.113 33.9784C197.132 33.8851 197.13 33.7885 197.106 33.6961L196.962 33.7502Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.936 34.0563C196.875 34.0861 196.81 34.1044 196.742 34.1104C196.638 34.124 196.541 34.1728 196.467 34.2488C196.396 34.3158 196.237 34.4423 196.155 34.3708L196.049 34.4826C196.176 34.5963 196.346 34.5486 196.508 34.4138C196.605 34.3359 196.63 34.2837 196.759 34.2635C196.863 34.2479 197.042 34.2232 197.08 34.1068C197.094 34.0632 197.105 34.0188 197.113 33.9738L196.961 33.9473C196.955 33.9841 196.946 34.0205 196.936 34.0563Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.053 34.4863L196.153 34.3708C196.129 34.3411 196.112 34.307 196.101 34.2705C196.091 34.234 196.088 34.1958 196.093 34.1581L195.939 34.1471C195.931 34.2086 195.937 34.2711 195.957 34.3298C195.977 34.3885 196.01 34.442 196.053 34.4863Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.354 33.7566L196.25 33.6393C196.212 33.6677 196.175 33.6983 196.14 33.7309C196.02 33.8402 195.947 33.9928 195.939 34.1553L196.093 34.1618C196.1 34.0407 196.154 33.9272 196.244 33.8455C196.264 33.8235 196.306 33.7914 196.354 33.7566Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.699 35.5083L196.748 35.3562C196.537 35.3264 196.322 35.3503 196.123 35.4258C195.924 35.5013 195.747 35.6258 195.609 35.7879L195.74 35.8686C195.858 35.7351 196.008 35.6326 196.175 35.5698C196.342 35.5071 196.522 35.486 196.699 35.5083Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.072 35.5615C197.101 35.6378 197.101 35.7217 197.072 35.798L197.205 35.8805C197.297 35.6898 197.226 35.4469 197.152 35.4222C197.019 35.3831 196.882 35.3609 196.743 35.3562L196.7 35.5083C196.826 35.512 196.951 35.5298 197.072 35.5615Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.072 35.798L197.066 35.8118C197.051 35.8493 196.989 35.9401 196.784 35.9337C196.703 35.9258 196.621 35.9341 196.544 35.9582C196.466 35.9823 196.394 36.0216 196.332 36.0739L196.438 36.1858C196.538 36.11 196.663 36.0753 196.787 36.0886C196.872 36.1004 196.957 36.0857 197.033 36.0466C197.109 36.0075 197.17 35.946 197.209 35.8704L197.072 35.798Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.196 36.3022C196.179 36.3606 196.139 36.41 196.086 36.4397L196.178 36.5662C196.26 36.5155 196.321 36.4357 196.347 36.3425C196.362 36.2798 196.397 36.2234 196.446 36.1812L196.334 36.0739C196.267 36.1354 196.219 36.2145 196.196 36.3022Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.086 36.4397C196.017 36.4684 195.942 36.4797 195.867 36.4727V36.6276C195.977 36.6387 196.088 36.6163 196.185 36.5634L196.086 36.4397Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.833 36.4644C195.828 36.4589 195.768 36.4122 195.752 36.3966L195.653 36.5158L195.734 36.5827C195.773 36.6112 195.819 36.6269 195.867 36.6276V36.4727C195.855 36.4721 195.844 36.4693 195.833 36.4644Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.691 36.3407C195.661 36.2824 195.646 36.2174 195.648 36.1518L195.495 36.1463C195.491 36.2418 195.512 36.3366 195.556 36.4213C195.585 36.4601 195.619 36.4946 195.657 36.524L195.749 36.4002C195.728 36.3822 195.708 36.3623 195.691 36.3407Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.74 35.875L195.613 35.7833C195.54 35.8918 195.499 36.019 195.495 36.15H195.648C195.652 36.0515 195.684 35.9561 195.74 35.875Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.947 36.8228L197.994 36.6725C197.756 36.6736 197.523 36.7408 197.321 36.8668C197.119 36.9927 196.956 37.1724 196.85 37.3857L196.975 37.4773C197.065 37.2923 197.203 37.1344 197.373 37.0194C197.544 36.9045 197.742 36.8367 197.947 36.8228Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.215 36.8219C198.194 36.7303 198.1 36.6863 197.994 36.6725L197.942 36.8228C197.985 36.8209 198.026 36.8314 198.062 36.8531C198.078 36.9092 198.082 36.9678 198.074 37.0254H198.23C198.235 36.9572 198.23 36.8886 198.215 36.8219Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.074 37.0254C198.047 37.1405 198.001 37.2506 197.94 37.3517L198.075 37.426C198.152 37.3007 198.205 37.162 198.23 37.0172L198.074 37.0254Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.94 37.3518C197.878 37.4425 197.808 37.5269 197.73 37.6038L197.804 37.7395C197.911 37.6476 198.004 37.5404 198.079 37.4214L197.94 37.3518Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73 37.6038C197.603 37.6708 197.474 37.5873 197.23 37.7193C197.095 37.7918 197.011 37.9833 196.955 38.0218C196.895 38.0604 196.824 38.0813 196.753 38.0823L196.744 38.2373C196.85 38.2387 196.954 38.209 197.042 38.152C197.144 38.0851 197.208 37.9128 197.312 37.8541C197.508 37.7432 197.644 37.8348 197.815 37.7377L197.73 37.6038Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.709 38.075L196.604 38.1969C196.646 38.2219 196.695 38.2343 196.744 38.2327V38.0777C196.732 38.0779 196.72 38.0769 196.709 38.075Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.977 37.4728L196.85 37.3857L196.654 37.7083V37.7175L196.797 37.778C196.854 37.6748 196.914 37.573 196.977 37.4728Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.589 38.1914C196.596 38.1959 196.602 38.1999 196.609 38.2033L196.709 38.0787C196.715 37.9704 196.747 37.8651 196.8 37.7707L196.652 37.7184C196.598 37.8083 196.494 38.1043 196.589 38.1914Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.744 39.4922C195.83 39.4729 195.878 39.4922 195.998 39.5838L196.084 39.4564C195.926 39.3409 195.858 39.3198 195.743 39.3363C195.592 39.3751 195.452 39.4486 195.334 39.5508L195.431 39.6718C195.525 39.5952 195.631 39.5345 195.744 39.4922Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.084 39.4555L195.993 39.5793C196.066 39.6286 196.129 39.6907 196.181 39.7626V39.7837L196.325 39.7223C196.269 39.6142 196.186 39.5223 196.084 39.4555Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.328 39.725L196.185 39.7919C196.2 39.8439 196.197 39.8994 196.177 39.9496L196.296 40.0486C196.323 39.9997 196.34 39.9457 196.345 39.8901C196.351 39.8345 196.345 39.7783 196.328 39.725Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.177 39.9459C196.143 39.9968 196.09 40.032 196.029 40.044C195.891 40.1071 195.762 40.1905 195.648 40.2915C195.578 40.3398 195.495 40.3651 195.41 40.3639V40.5179C195.527 40.5207 195.642 40.4864 195.739 40.4198C195.843 40.3294 195.958 40.2524 196.082 40.1907C196.172 40.1674 196.251 40.1136 196.305 40.0385L196.177 39.9459Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.278 40.2979L195.195 40.4281C195.256 40.4785 195.331 40.5103 195.41 40.5198V40.3667C195.362 40.3522 195.317 40.3289 195.278 40.2979Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.114 40.3667C195.142 40.3904 195.17 40.4121 195.201 40.4318L195.278 40.2979C195.259 40.2853 195.24 40.2715 195.223 40.2567C195.194 40.2099 195.175 40.1573 195.169 40.1027L195.016 40.1283C195.027 40.2153 195.061 40.2977 195.114 40.3667Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.175 39.9129C195.249 39.8181 195.338 39.7353 195.437 39.6673L195.335 39.5499C195.223 39.6281 195.123 39.7245 195.042 39.835C195.003 39.9293 194.995 40.0337 195.019 40.1329L195.17 40.1027C195.155 40.0402 195.156 39.9746 195.175 39.9129Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.288 37.1464C200.333 37.1001 200.388 37.064 200.448 37.0403C200.508 37.0166 200.573 37.0059 200.637 37.0089C200.677 37.0075 200.716 37.0125 200.754 37.0236L200.835 37.1042L200.952 37.0025L200.855 36.9062C200.79 36.8653 200.714 36.8469 200.637 36.854C200.55 36.8508 200.462 36.8666 200.381 36.9005C200.3 36.9344 200.227 36.9854 200.167 37.0502C200.082 37.1339 199.988 37.2086 199.887 37.2729L199.993 37.3866C200.101 37.3197 200.201 37.2389 200.288 37.1464Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.835 37.1043C200.934 37.1876 201.004 37.3007 201.034 37.4269C201.034 37.445 201.03 37.4628 201.022 37.4792L201.164 37.5424C201.255 37.3435 201.072 37.129 200.946 36.997L200.835 37.1043Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.165 37.5378L201.022 37.4792C201.015 37.4949 201.005 37.5095 200.993 37.5223C200.959 37.535 200.923 37.5436 200.887 37.5479L200.946 37.6946C201.001 37.6889 201.052 37.6693 201.097 37.6378C201.126 37.609 201.149 37.5751 201.165 37.5378Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.263 37.7184L200.327 37.8614C200.519 37.7563 200.733 37.6987 200.952 37.6937L200.887 37.5479C200.668 37.5544 200.455 37.6129 200.263 37.7184Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.332 37.8578L200.263 37.7184C200.066 37.8413 199.897 38.0484 199.738 38.1438C199.738 38.1438 199.363 38.3913 199.28 38.3766L199.31 38.5297C199.494 38.4725 199.668 38.3861 199.824 38.2739C200.033 38.1392 200.152 37.9742 200.332 37.8578Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.168 38.339L199.086 38.4664C199.152 38.5142 199.232 38.5364 199.313 38.5288L199.276 38.3766C199.237 38.3747 199.2 38.3617 199.168 38.339Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.092 38.4701L199.168 38.339C199.082 38.2849 198.968 38.064 199.158 37.7267L199.041 37.6231C198.769 38.0686 198.95 38.3748 199.092 38.4701Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.293 37.6167C199.543 37.6081 199.785 37.5297 199.993 37.3903L199.893 37.272C199.709 37.3988 199.491 37.4657 199.268 37.4636C199.219 37.4741 199.173 37.495 199.133 37.5247C199.093 37.5544 199.06 37.5923 199.035 37.6359L199.158 37.7276C199.172 37.7008 199.19 37.677 199.214 37.6579C199.237 37.6388 199.264 37.6248 199.293 37.6167Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.551 40.7727L197.592 40.6233C197.307 40.5873 197.018 40.655 196.778 40.814L196.878 40.9322C197.079 40.8065 197.315 40.7505 197.551 40.7727Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.592 40.6233L197.545 40.7709C197.587 40.7785 197.626 40.8012 197.654 40.8348C197.682 40.8683 197.697 40.9107 197.696 40.9543L197.847 40.9167C197.841 40.8471 197.813 40.7812 197.767 40.7285C197.722 40.6758 197.66 40.639 197.592 40.6233Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.696 40.9497C197.701 41.0088 197.688 41.068 197.66 41.1202L197.788 41.2118C197.842 41.1207 197.862 41.0138 197.846 40.9093L197.696 40.9497Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.778 41.3044L196.695 41.4355C196.878 41.5243 197.086 41.5495 197.285 41.5071C197.484 41.4648 197.663 41.3574 197.795 41.2018L197.662 41.1202C197.467 41.4511 196.896 41.3814 196.778 41.3044Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.578 41.1651C196.567 41.218 196.572 41.2731 196.595 41.3224C196.617 41.3718 196.654 41.4129 196.7 41.4401L196.778 41.3063C196.766 41.2991 196.755 41.2897 196.746 41.2788C196.737 41.2638 196.731 41.2472 196.728 41.2298C196.726 41.2125 196.727 41.1948 196.732 41.1779L196.578 41.1651Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.743 41.1257C196.751 41.0861 196.768 41.0485 196.791 41.0153C196.814 40.9821 196.844 40.9539 196.878 40.9323L196.787 40.8094C196.691 40.8739 196.623 40.9721 196.597 41.0844C196.588 41.1144 196.582 41.145 196.578 41.1761L196.733 41.1816C196.735 41.1627 196.738 41.144 196.743 41.1257Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.658 41.0276C192.901 40.9215 193.152 40.8338 193.409 40.7654C193.442 40.7585 193.477 40.7617 193.509 40.7746L193.573 40.6325C193.52 40.6114 193.463 40.6035 193.407 40.6096C193.113 40.6771 192.829 40.7777 192.558 40.9093C192.51 40.9595 192.481 41.024 192.474 41.0927L192.618 41.1587C192.618 41.112 192.632 41.0664 192.658 41.0276Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.573 40.6325L193.504 40.7718C193.543 40.7893 193.585 40.8433 193.603 41.0047C193.603 41.0707 193.582 41.135 193.542 41.188L193.674 41.2696C193.732 41.1897 193.761 41.0929 193.757 40.9946C193.732 40.7663 193.657 40.671 193.573 40.6325Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.678 41.2595L193.542 41.1843C193.485 41.2723 193.412 41.3488 193.327 41.4098L193.405 41.5455C193.513 41.4676 193.605 41.3707 193.678 41.2595Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.903 41.6399L192.911 41.7994C193.089 41.7376 193.258 41.6506 193.411 41.5409L193.327 41.4098C193.196 41.5043 193.054 41.5816 192.903 41.6399Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.904 41.6399C192.857 41.6577 192.808 41.6679 192.758 41.6702L192.751 41.8242C192.808 41.8236 192.864 41.8147 192.917 41.7976L192.904 41.6399Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67 41.6372L192.572 41.7563C192.622 41.8013 192.688 41.8256 192.755 41.8242V41.6702C192.739 41.6714 192.723 41.6691 192.709 41.6634C192.694 41.6577 192.681 41.6487 192.67 41.6372Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.465 41.4236C192.469 41.5325 192.498 41.6391 192.55 41.7353C192.558 41.7448 192.568 41.7537 192.578 41.7618L192.67 41.6372C192.637 41.5604 192.62 41.4784 192.617 41.3952L192.465 41.4236Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.619 41.1477L192.474 41.089C192.455 41.2015 192.453 41.3159 192.466 41.4291L192.618 41.3952C192.611 41.3128 192.611 41.23 192.619 41.1477Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.102 42.3751L196.178 42.2403C196.084 42.184 196 42.1128 195.929 42.0295C195.915 42.0168 195.898 42.0071 195.88 42.0011C195.862 41.9951 195.842 41.9929 195.823 41.9947C195.743 41.9991 195.665 42.0237 195.596 42.0661C195.528 42.1086 195.471 42.1675 195.432 42.2376L195.561 42.3293C195.587 42.28 195.624 42.238 195.671 42.2072C195.717 42.1765 195.77 42.1579 195.826 42.1533C195.905 42.2417 195.998 42.3167 196.102 42.3751Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.576 42.4429L196.172 42.2367L196.102 42.3751C196.237 42.445 196.373 42.5141 196.509 42.5823C196.517 42.5853 196.525 42.5907 196.531 42.5978C196.537 42.6049 196.54 42.6135 196.542 42.6226L196.698 42.6409C196.699 42.5996 196.688 42.5587 196.667 42.5234C196.645 42.4882 196.613 42.4601 196.576 42.4429Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.542 42.6226C196.544 42.6508 196.54 42.6791 196.531 42.7058C196.522 42.7324 196.507 42.7569 196.488 42.7775L196.606 42.8765C196.664 42.809 196.696 42.7234 196.698 42.6345L196.542 42.6226Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.488 42.7775C196.38 42.8994 196.029 42.8692 195.994 42.8692L195.987 43.0241C196.025 43.0241 196.465 43.0727 196.611 42.8738L196.488 42.7775Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.682 42.7885L195.616 42.9278C195.736 42.9799 195.863 43.0109 195.994 43.0195V42.8646C195.886 42.856 195.781 42.8303 195.682 42.7885Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.488 42.8417C195.528 42.877 195.573 42.9061 195.622 42.9278L195.682 42.7858C195.654 42.7722 195.627 42.7556 195.603 42.7363L195.488 42.8417Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.542 42.6583L195.411 42.739C195.433 42.7799 195.462 42.8163 195.498 42.8462L195.608 42.7363C195.581 42.715 195.558 42.6885 195.542 42.6583Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.513 42.5218L195.36 42.5318C195.358 42.6067 195.375 42.6808 195.41 42.7473L195.537 42.6611C195.517 42.6174 195.509 42.5695 195.513 42.5218Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.561 42.3256L195.434 42.2339C195.382 42.3265 195.356 42.4319 195.36 42.5383L195.513 42.5227C195.513 42.4541 195.529 42.3864 195.561 42.3256Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.162 41.7518C199.084 41.7087 199.013 41.6381 198.921 41.6381C198.856 41.6421 198.794 41.6655 198.742 41.7054C198.69 41.7453 198.651 41.7997 198.631 41.8618L198.766 41.9406C198.777 41.9047 198.797 41.8722 198.824 41.8462C198.851 41.8202 198.884 41.8016 198.921 41.7921C198.979 41.8173 199.035 41.8479 199.087 41.8838C199.161 41.9248 199.245 41.9457 199.329 41.9443L199.361 41.7875C199.292 41.7969 199.222 41.7844 199.162 41.7518Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.526 41.7747C199.477 41.7747 199.403 41.7875 199.354 41.7921L199.329 41.9479C199.378 41.9479 199.485 41.9296 199.526 41.9296C199.617 41.9296 199.68 41.9653 199.739 42.1588C199.752 42.2044 199.755 42.2522 199.747 42.299L199.892 42.3632C199.913 42.2813 199.913 42.1957 199.892 42.1138C199.835 41.9452 199.758 41.7747 199.526 41.7747Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.893 42.3577L199.747 42.299C199.744 42.3218 199.739 42.3442 199.732 42.3659L199.817 42.4988C199.866 42.475 199.879 42.4173 199.893 42.3577Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.732 42.3659C199.658 42.3659 199.614 42.3412 199.515 42.3393C199.348 42.3531 199.183 42.3885 199.025 42.4448L199.053 42.5978C199.205 42.5441 199.363 42.5093 199.524 42.4943C199.615 42.4943 199.737 42.552 199.823 42.4943L199.732 42.3659Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.85 42.4228L198.763 42.5511C198.806 42.5792 198.855 42.5977 198.906 42.6055C198.956 42.6132 199.008 42.61 199.058 42.596L199.025 42.4448C198.996 42.4543 198.965 42.4573 198.935 42.4535C198.905 42.4497 198.876 42.4392 198.85 42.4228Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.772 42.3403L198.643 42.4228C198.674 42.4759 198.717 42.5208 198.768 42.5538L198.85 42.4228C198.818 42.4019 198.791 42.3736 198.772 42.3403Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.729 42.2284L198.582 42.2788C198.596 42.332 198.617 42.3827 198.646 42.4292L198.772 42.3375C198.752 42.3036 198.738 42.2668 198.729 42.2284Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.766 41.9406L198.634 41.8562C198.567 41.9889 198.55 42.1409 198.584 42.2852L198.729 42.2284C198.712 42.131 198.725 42.0308 198.766 41.9406Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.669 34.4221C198.836 34.3152 199.023 34.2454 199.219 34.2177C199.321 34.2247 199.421 34.2409 199.519 34.2663L199.57 34.1196C199.456 34.0889 199.338 34.0702 199.219 34.0637C199.013 34.0846 198.814 34.1534 198.638 34.2644C198.553 34.3016 198.478 34.3608 198.423 34.4358L198.548 34.5275C198.579 34.4823 198.62 34.4459 198.669 34.4221Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.563 34.1187L199.517 34.2663C199.619 34.2865 199.718 34.3154 199.814 34.3524L199.934 34.2525C199.905 34.2012 199.698 34.1498 199.563 34.1187Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.929 34.2452L199.814 34.3524C199.833 34.4072 199.829 34.4668 199.805 34.5193L199.946 34.5807C199.972 34.5279 199.984 34.4694 199.981 34.4106C199.978 34.3519 199.96 34.2949 199.929 34.2452Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.805 34.5193C199.778 34.5842 199.727 34.6359 199.662 34.6632C199.558 34.7081 199.047 35.0647 198.929 35.1215L198.996 35.2618C199.096 35.2132 199.649 34.8346 199.729 34.8034C199.78 34.782 199.826 34.7507 199.865 34.7111C199.904 34.6716 199.934 34.6248 199.955 34.5733L199.805 34.5193Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.846 35.1563L198.864 35.3103C198.911 35.2996 198.957 35.2833 199 35.2618L198.928 35.1243C198.901 35.1369 198.874 35.1476 198.846 35.1563Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.536 35.1609L198.519 35.3149C198.635 35.335 198.753 35.3332 198.868 35.3094L198.846 35.1563C198.744 35.1779 198.639 35.1795 198.536 35.1609Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.464 35.1133L198.367 35.2343C198.411 35.2759 198.466 35.3045 198.525 35.3168L198.536 35.1609C198.51 35.1493 198.485 35.1331 198.464 35.1133Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.366 34.9583L198.212 34.9803C198.232 35.0842 198.289 35.1774 198.372 35.2425L198.464 35.1169C198.414 35.0771 198.379 35.021 198.366 34.9583Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.368 34.9024C198.407 34.768 198.467 34.6408 198.547 34.5257L198.426 34.434C198.333 34.567 198.262 34.7144 198.217 34.8703C198.208 34.9081 198.207 34.9474 198.213 34.9858L198.366 34.9583C198.362 34.9398 198.363 34.9207 198.368 34.9024Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.935 32.8748C211.654 32.8995 211.471 32.7116 211.243 32.718C211.128 32.7514 211.017 32.795 210.91 32.8482L211.01 32.9719C211.092 32.9341 211.175 32.9007 211.26 32.872C211.388 32.8638 211.65 33.0553 211.94 33.0288C212.057 33.041 212.171 33.072 212.278 33.1204L212.354 32.9838C212.221 32.9266 212.08 32.8898 211.935 32.8748Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.767 33.3083C212.673 33.1508 212.524 33.0345 212.348 32.9829L212.278 33.1213C212.436 33.1846 212.59 33.2735 212.621 33.3615C212.639 33.4292 212.632 33.501 212.602 33.5641L212.739 33.6356C212.787 33.5333 212.797 33.4172 212.767 33.3083Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.602 33.5623C212.577 33.6319 212.537 33.6947 212.483 33.7456C212.401 33.7451 212.319 33.7299 212.241 33.7007C211.96 33.5424 211.651 33.4385 211.331 33.3945V33.5494C211.625 33.5947 211.908 33.6925 212.166 33.8382C212.285 33.8903 212.415 33.9071 212.543 33.8868C212.633 33.8238 212.701 33.7344 212.737 33.631L212.602 33.5623Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.331 33.3908C211.209 33.3963 211.01 33.5137 210.913 33.5201L210.904 33.6741C211.034 33.6741 211.232 33.5522 211.341 33.5448L211.331 33.3908Z",
    fill: "#EC9C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.913 33.5201C210.864 33.5079 210.818 33.4864 210.778 33.4568L210.677 33.576C210.746 33.6277 210.826 33.6614 210.911 33.6741V33.5201H210.913Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.683 33.5833L210.775 33.4605C210.719 33.4211 210.625 33.3615 210.628 33.3074L210.475 33.3285C210.483 33.4504 210.613 33.5283 210.683 33.5833Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.715 33.1149C210.765 33.0847 210.89 33.0233 211.01 32.9719L210.919 32.8454L210.638 32.982C210.585 33.0221 210.542 33.0751 210.515 33.136C210.488 33.1969 210.476 33.2638 210.482 33.3303L210.634 33.3038C210.633 33.2683 210.641 33.2333 210.655 33.2007C210.669 33.1682 210.689 33.139 210.715 33.1149Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.032 33.7172C213.885 33.7772 213.757 33.8741 213.659 33.9986C213.471 34.1705 213.314 34.3737 213.195 34.599C213.133 34.7587 213.09 34.9251 213.067 35.0949L213.221 35.105C213.248 34.9256 213.298 34.7503 213.369 34.5834C213.487 34.4087 213.624 34.2468 213.776 34.1003C213.851 34.0031 213.947 33.9241 214.056 33.8693C214.183 33.8822 214.305 33.9212 214.416 33.9839L214.513 33.8593C214.367 33.7728 214.201 33.724 214.032 33.7172Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.765 34.0114C214.684 33.9524 214.598 33.9006 214.508 33.8565L214.417 33.9839C214.506 34.0259 214.591 34.0759 214.671 34.1333C214.686 34.1462 214.711 34.1673 214.684 34.247L214.825 34.3121C214.85 34.2627 214.859 34.2059 214.848 34.1513C214.837 34.0966 214.808 34.0473 214.765 34.0114Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.684 34.247C214.65 34.3421 214.585 34.4233 214.5 34.478L214.535 34.6283C214.602 34.5966 214.662 34.5518 214.712 34.4966C214.762 34.4413 214.8 34.3768 214.825 34.3066L214.684 34.247Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.398 34.6622L214.542 34.6274L214.501 34.478L214.364 34.511C214.305 34.5166 214.248 34.5331 214.195 34.5596L214.257 34.7026C214.301 34.6801 214.349 34.6664 214.398 34.6622Z",
    fill: "#EC9C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.992 34.7448C213.856 34.9437 213.699 35.1281 213.524 35.2948C213.462 35.3203 213.393 35.3251 213.328 35.3085L213.245 35.4396C213.3 35.4622 213.359 35.4732 213.419 35.4721C213.478 35.471 213.537 35.4578 213.591 35.4332C213.791 35.263 213.967 35.0651 214.111 34.8456C214.153 34.7894 214.205 34.7407 214.263 34.7017L214.195 34.5623C214.117 34.6103 214.048 34.6721 213.992 34.7448Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.252 35.4396L213.328 35.3058C213.29 35.2891 213.259 35.2603 213.24 35.2238C213.22 35.1874 213.214 35.1455 213.221 35.105L213.068 35.0885C213.057 35.1589 213.069 35.2311 213.102 35.2943C213.135 35.3575 213.188 35.4084 213.252 35.4396Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.12 33.4697C216.108 33.4275 216.106 33.3833 216.113 33.3401C216.12 33.297 216.136 33.2558 216.161 33.2195C216.185 33.1832 216.217 33.1525 216.254 33.1296C216.291 33.1066 216.333 33.0919 216.377 33.0865C216.572 33.0803 216.766 33.1095 216.951 33.1727C217.129 33.2778 217.298 33.399 217.454 33.5348C217.52 33.5774 217.589 33.6163 217.66 33.6512L217.766 33.532C217.69 33.4966 217.616 33.4559 217.545 33.4101C217.382 33.2667 217.204 33.1402 217.015 33.0324C216.803 32.9579 216.579 32.924 216.355 32.9325C215.916 32.9912 215.896 33.5228 216.033 33.6099L216.139 33.4706L216.12 33.4697Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 34.2443C218.044 34.3621 218.073 34.4855 218.084 34.6109L218.239 34.6274C218.227 34.4606 218.189 34.2965 218.128 34.1407C218.091 33.9603 218.018 33.7894 217.913 33.6383C217.87 33.594 217.819 33.5577 217.763 33.5311L217.664 33.6539C217.713 33.6753 217.758 33.7047 217.797 33.741C217.895 33.8951 217.963 34.0656 218 34.2443Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.081 34.6082C218.088 34.6745 218.072 34.7413 218.035 34.797L218.115 34.9345C218.157 34.8943 218.19 34.8451 218.211 34.7906C218.232 34.736 218.24 34.6774 218.236 34.6192L218.081 34.6082Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.804 34.775L217.772 34.9263C217.853 34.9446 218.065 34.9767 218.122 34.9318L218.035 34.7988C217.957 34.8018 217.879 34.7938 217.804 34.775Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45 34.5798L217.339 34.6879C217.458 34.8126 217.614 34.8961 217.784 34.9263L217.808 34.7732C217.671 34.7493 217.545 34.6814 217.45 34.5798Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.416 34.5312C217.315 34.3391 217.198 34.1553 217.069 33.9812C217.011 33.8713 216.933 33.773 216.839 33.6915L216.739 33.8088C216.838 33.9024 216.921 34.0129 216.982 34.1352C217.092 34.2797 217.19 34.433 217.274 34.5935C217.29 34.631 217.312 34.6657 217.339 34.6962L217.445 34.5825C217.433 34.567 217.423 34.5497 217.416 34.5312Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.139 33.4706L216.026 33.6053C216.038 33.6157 216.054 33.6221 216.07 33.6237C216.309 33.6119 216.545 33.6761 216.745 33.807L216.837 33.6851C216.631 33.5446 216.388 33.4698 216.139 33.4706Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.374 35.2865C216.378 35.2163 216.378 35.1459 216.374 35.0757C216.368 35.033 216.347 34.9938 216.315 34.965C216.283 34.9362 216.242 34.9195 216.199 34.918C215.92 34.9309 215.643 34.9752 215.374 35.05C215.246 35.09 215.128 35.159 215.031 35.2517L215.161 35.3433C215.238 35.2788 215.326 35.2302 215.421 35.2003C215.678 35.1253 215.944 35.0855 216.212 35.0821C216.225 35.0922 216.233 35.1206 216.228 35.1738C216.219 35.2486 216.225 35.3245 216.246 35.3969C216.267 35.4693 216.303 35.5365 216.351 35.5945L216.477 35.5028C216.442 35.4827 216.393 35.4533 216.374 35.2865Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.464 35.4983L216.343 35.5963L216.655 35.8585L216.757 35.7421L216.464 35.4983Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.751 35.7366L216.659 35.8585L216.772 35.963C216.766 35.9935 216.756 36.0229 216.741 36.0501L216.874 36.1298C216.931 36.0217 216.947 35.9227 216.893 35.8658L216.751 35.7366Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.873 36.1234L216.738 36.0501C216.695 36.1396 216.623 36.2121 216.534 36.2563L216.574 36.4058C216.705 36.3512 216.811 36.2509 216.873 36.1234Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.533 36.2563C216.527 36.2575 216.521 36.2575 216.515 36.2563C216.319 36.2304 216.128 36.1757 215.948 36.0941L215.905 36.2453C216.115 36.3465 216.346 36.3997 216.579 36.4012L216.533 36.2563Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.948 36.0968C215.896 36.0576 215.849 36.012 215.808 35.9612C215.758 35.8981 215.699 35.8423 215.633 35.7952L215.552 35.9254C215.649 35.9878 215.729 36.1335 215.861 36.2243C215.877 36.2345 215.894 36.2434 215.912 36.2508L215.948 36.0968Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.447 35.7513C215.33 35.7513 215.112 35.7907 215.08 35.7824C215.022 35.7656 214.968 35.734 214.925 35.6908L214.779 35.7503C214.841 35.839 214.933 35.902 215.038 35.9273C215.175 35.9295 215.312 35.9212 215.447 35.9025C215.486 35.8993 215.524 35.9076 215.558 35.9263L215.633 35.7916C215.576 35.7615 215.512 35.7475 215.447 35.7513Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91 35.6715C214.91 35.6715 214.904 35.6541 214.925 35.622C214.987 35.518 215.064 35.4233 215.153 35.3406L215.028 35.2489C214.938 35.3359 214.86 35.4339 214.794 35.5404C214.77 35.572 214.756 35.6102 214.754 35.65C214.752 35.6897 214.762 35.7291 214.783 35.7632L214.926 35.6963C214.919 35.6891 214.914 35.6807 214.91 35.6715Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.275 36.6248C218.332 36.5469 218.411 36.3654 218.496 36.3572C218.581 36.3489 218.662 36.502 218.792 36.7843L218.94 36.733C218.873 36.6028 218.734 36.1995 218.496 36.2032C218.319 36.2032 218.232 36.4085 218.16 36.5194C218.115 36.59 217.943 36.6945 217.88 36.8568L218.029 36.9017C218.071 36.8018 218.232 36.6826 218.275 36.6248Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.936 36.7266L218.791 36.7843L218.899 37.0291L219.048 36.986C219.015 36.8975 218.978 36.8109 218.936 36.7266Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.045 36.9796L218.899 37.0291C218.911 37.0693 218.911 37.1117 218.899 37.1519L219.043 37.2088C219.067 37.1343 219.068 37.0544 219.045 36.9796Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.04 37.2033L218.895 37.1519C218.886 37.1864 218.872 37.2194 218.853 37.25L218.97 37.3508C219.001 37.3059 219.025 37.256 219.04 37.2033ZM218.667 37.3316C218.467 37.323 218.271 37.2707 218.094 37.1785L218.002 37.2995C218.208 37.4128 218.437 37.4756 218.672 37.4828C218.733 37.485 218.793 37.4753 218.851 37.4544L218.792 37.3114C218.752 37.3265 218.71 37.3334 218.667 37.3316Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.02 37.1263L217.882 37.1932C217.911 37.2403 217.953 37.2784 218.003 37.3032L218.094 37.1785C218.067 37.1651 218.042 37.1474 218.02 37.1263Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.028 36.9017L217.882 36.8494C217.858 36.9046 217.845 36.9642 217.845 37.0245C217.845 37.0848 217.858 37.1444 217.882 37.1996L218.017 37.1263C218.003 37.0899 217.998 37.0513 218 37.0127C218.002 36.9742 218.012 36.9364 218.028 36.9017Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.191 38.0273L219.511 38.0438C219.455 38.0348 219.397 38.039 219.343 38.056C219.289 38.073 219.239 38.1025 219.198 38.1419L219.314 38.2464C219.337 38.2246 219.366 38.2087 219.397 38.2001C219.427 38.1915 219.46 38.1904 219.491 38.1969C219.628 38.2107 219.906 38.1878 220.2 38.1813C220.393 38.1854 220.586 38.2138 220.772 38.2657L220.821 38.119C220.616 38.0602 220.404 38.0293 220.191 38.0273Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.821 38.119L220.765 38.2638C220.865 38.2932 220.942 38.3335 220.948 38.3894C220.949 38.4709 220.945 38.5523 220.935 38.6333L221.085 38.6809C221.097 38.5814 221.103 38.4813 221.102 38.3812C221.092 38.2437 220.972 38.1667 220.821 38.119Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.933 38.6333C220.927 38.7409 220.905 38.8471 220.868 38.9486L220.971 39.0641C221.045 38.9478 221.084 38.8125 221.084 38.6745L220.933 38.6333Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.976 39.0586L220.867 38.9486C220.782 39.0157 220.676 39.0505 220.568 39.0467L220.581 39.2025C220.726 39.2027 220.866 39.1517 220.976 39.0586Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.475 39.0146C220.413 38.9537 220.341 38.9038 220.262 38.867L220.201 39.0091C220.263 39.0381 220.319 39.0774 220.367 39.1255C220.429 39.1795 220.509 39.2072 220.591 39.2025L220.571 39.0467C220.536 39.0472 220.503 39.0359 220.475 39.0146Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.752 38.7845H219.556C219.498 38.7827 219.441 38.7699 219.388 38.7469L219.282 38.8661C219.364 38.9111 219.455 38.9363 219.548 38.9394H219.752C219.905 38.9279 220.059 38.9524 220.202 39.0109L220.259 38.867C220.098 38.8017 219.925 38.7735 219.752 38.7845Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.283 38.6589L219.148 38.7368C219.184 38.7903 219.233 38.8348 219.289 38.867L219.389 38.7442C219.347 38.725 219.311 38.6957 219.283 38.6589Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.319 38.2409L219.198 38.1419C219.124 38.2223 219.079 38.3254 219.07 38.4345C219.062 38.5436 219.09 38.6524 219.151 38.7433L219.282 38.6589C219.238 38.5963 219.217 38.5198 219.224 38.4432C219.23 38.3666 219.264 38.2949 219.319 38.2409Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.526 39.571C218.447 39.5835 218.372 39.6166 218.31 39.667C218.248 39.7173 218.2 39.7832 218.171 39.8579C218.165 39.9358 218.17 40.0141 218.185 40.0908L218.34 40.0834C218.327 40.0195 218.321 39.9543 218.322 39.8891C218.364 39.8109 218.435 39.7523 218.52 39.7259C218.598 39.7737 218.667 39.8359 218.722 39.9093L218.846 39.8176C218.739 39.6847 218.605 39.571 218.526 39.571Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.841 39.8103L218.722 39.9074C218.777 39.9653 218.82 40.0331 218.849 40.1073L218.999 40.0715C218.963 39.9755 218.91 39.8869 218.841 39.8103Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.997 40.0651L218.849 40.1073V40.2209L219.003 40.2438C219.008 40.1842 219.006 40.1243 218.997 40.0651Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.816 40.3108C218.704 40.3345 218.589 40.3413 218.476 40.3309L218.403 40.4794C218.568 40.5048 218.737 40.4922 218.896 40.4428C218.931 40.4207 218.958 40.3902 218.977 40.3542C218.996 40.3183 219.005 40.278 219.004 40.2374L218.85 40.2209C218.849 40.275 218.841 40.2933 218.816 40.3108Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.399 40.3217L218.301 40.451C218.334 40.4678 218.371 40.4777 218.409 40.4803L218.476 40.3309C218.45 40.3293 218.424 40.3262 218.399 40.3217Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.399 40.3218C218.371 40.2444 218.352 40.1646 218.34 40.0834H218.183C218.191 40.2142 218.233 40.3405 218.305 40.4501L218.397 40.3172L218.399 40.3218Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.559 41.7948L221.638 41.9287C221.792 41.8728 222.069 41.8132 222.164 41.9076L222.276 41.8003C222.103 41.6262 221.712 41.7288 221.559 41.7948Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.269 41.7939L222.164 41.9076C222.249 41.9848 222.303 42.0905 222.315 42.2046L222.472 42.2367C222.465 42.0681 222.392 41.909 222.269 41.7939Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.465 42.3467C222.471 42.3085 222.474 42.2698 222.472 42.2312L222.315 42.2046C222.318 42.2332 222.318 42.2621 222.315 42.2908L222.305 42.2972L222.421 42.4035C222.442 42.3901 222.457 42.37 222.465 42.3467Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 42.2972C222.253 42.3265 222.195 42.3499 222.134 42.3668L222.152 42.5227C222.25 42.4983 222.343 42.4564 222.427 42.3989L222.308 42.2972Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.715 42.4429C221.696 42.4386 221.678 42.4325 221.66 42.4246L221.569 42.552C221.605 42.572 221.644 42.5866 221.685 42.5951C221.845 42.5948 222.003 42.5697 222.155 42.5208L222.131 42.3668C221.997 42.4116 221.857 42.4372 221.715 42.4429Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.33 42.1083C221.325 42.1747 221.332 42.2414 221.35 42.3054L221.499 42.2642C221.485 42.2156 221.48 42.165 221.484 42.1148L221.33 42.1083Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.638 41.925L221.564 41.7884C221.495 41.81 221.435 41.8534 221.392 41.9121C221.35 41.9707 221.328 42.0415 221.329 42.1138H221.484C221.489 42.0616 221.483 41.9855 221.638 41.925Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.433 41.5052C219.282 41.5052 219.15 41.6757 219.026 41.7738C218.968 41.823 218.894 41.8505 218.818 41.8517C218.682 41.8517 218.369 41.7023 218.237 41.705C218.133 41.7188 218.036 41.7661 217.962 41.8398L218.085 41.9314C218.155 41.8773 218.202 41.8526 218.242 41.8563C218.401 41.8718 218.587 41.9864 218.792 42.0029C219.106 42.0268 219.292 41.661 219.425 41.6555C219.497 41.6675 219.567 41.6947 219.628 41.7353L219.7 41.5987C219.62 41.5459 219.528 41.5138 219.433 41.5052Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.912 41.8746C219.903 41.8151 219.879 41.7589 219.842 41.7109C219.806 41.663 219.758 41.6247 219.703 41.5996L219.636 41.7398C219.666 41.7586 219.694 41.7811 219.719 41.8068C219.748 41.8388 219.757 41.859 219.757 41.8746V42.0057L219.914 42.0139L219.912 41.8746Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.891 42.1734C219.912 42.1205 219.921 42.0634 219.916 42.0066H219.759C219.761 42.0397 219.759 42.073 219.753 42.1056C219.747 42.1114 219.741 42.1166 219.734 42.1212L219.836 42.2376C219.859 42.2202 219.877 42.1984 219.891 42.1734Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.734 42.1193C219.624 42.1844 219.532 42.1927 219.459 42.2468C219.364 42.3369 219.277 42.4361 219.2 42.5428L219.284 42.6776C219.4 42.5685 219.447 42.4484 219.552 42.3714C219.651 42.3306 219.748 42.2838 219.842 42.2312L219.734 42.1193Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.027 42.42L217.936 42.5465C218.291 42.7433 218.701 42.819 219.103 42.7619L219.067 42.6125C218.709 42.6567 218.346 42.5895 218.027 42.42Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.201 42.5428C219.166 42.581 219.119 42.6057 219.068 42.6125L219.097 42.7638C219.169 42.7507 219.236 42.7191 219.292 42.6721L219.201 42.5428Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.888 42.321L217.743 42.3733C217.789 42.452 217.859 42.514 217.943 42.5502L218.028 42.42C217.974 42.3989 217.926 42.3649 217.888 42.321Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.092 41.9351L217.973 41.8343C217.808 41.9763 217.684 42.2504 217.749 42.3797L217.891 42.321C217.892 42.2455 217.911 42.1713 217.946 42.1044C217.981 42.0374 218.031 41.9794 218.092 41.9351Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.868 39.1319C215.726 39.1314 215.585 39.1591 215.454 39.2134C215.323 39.2677 215.204 39.3475 215.103 39.4482L215.245 39.516C215.425 39.3675 215.652 39.2865 215.886 39.2868C216.041 39.2957 216.194 39.333 216.335 39.3968L216.396 39.2548C216.229 39.181 216.05 39.1394 215.868 39.1319Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56 39.3345C216.505 39.3033 216.449 39.276 216.39 39.2529L216.335 39.3968C216.386 39.4168 216.434 39.4404 216.481 39.4674C216.603 39.5558 216.693 39.6802 216.74 39.8231L216.894 39.8011C216.84 39.6115 216.722 39.4464 216.56 39.3345Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.74 39.8231C216.755 39.8799 216.758 39.939 216.751 39.9973L216.9 40.0431C216.915 39.9606 216.912 39.876 216.892 39.7947L216.74 39.8231Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.9 40.0358L216.751 40V40.0202C216.747 40.0603 216.73 40.098 216.702 40.1274H216.684L216.762 40.2658C216.802 40.2407 216.834 40.2069 216.858 40.167C216.882 40.127 216.896 40.0821 216.9 40.0358Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.681 40.1283H216.642C216.547 40.1276 216.454 40.1086 216.367 40.0724C216.321 40.0495 216.176 39.9588 216.149 39.9432L216.083 40.0843L216.298 40.2108C216.405 40.2573 216.521 40.2819 216.638 40.2833C216.68 40.285 216.723 40.2778 216.762 40.2622L216.681 40.1283Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.998 39.8662L215.955 39.8515L215.902 39.9982C215.913 39.9982 215.931 40.0055 215.941 40.0101C215.994 40.0323 216.044 40.0587 216.092 40.0889L216.153 39.945C216.104 39.9144 216.052 39.888 215.998 39.8662Z",
    fill: "#EC9C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.544 39.7901C215.472 39.7901 215.385 39.7782 215.315 39.7681L215.255 39.9148C215.353 39.9313 215.478 39.9413 215.536 39.945C215.662 39.9468 215.787 39.9653 215.908 40L215.955 39.8515C215.821 39.8127 215.683 39.7921 215.544 39.7901Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.173 39.725L215.035 39.7974C215.062 39.832 215.096 39.8603 215.135 39.8802C215.175 39.9002 215.218 39.9113 215.262 39.9129L215.315 39.7653C215.265 39.763 215.217 39.7492 215.173 39.725Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.166 39.7177C215.17 39.6437 215.197 39.573 215.245 39.516L215.107 39.4418C215.062 39.5087 214.96 39.6865 215.038 39.8084L215.173 39.7296L215.166 39.7177Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.391 41.65C215.223 41.6995 214.971 41.7362 214.802 41.771C214.757 41.7817 214.716 41.8016 214.68 41.8294C214.644 41.8572 214.614 41.8922 214.592 41.9323L214.738 41.9919C214.758 41.9575 214.791 41.9325 214.829 41.9223L215.431 41.7985C215.586 41.7332 215.749 41.6882 215.916 41.6647C216.022 41.6641 216.127 41.6899 216.22 41.7398L216.323 41.6216C216.2 41.5475 216.059 41.5091 215.916 41.5107C215.736 41.5321 215.559 41.579 215.391 41.65Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48 41.8828C216.48 41.828 216.465 41.7743 216.437 41.7273C216.409 41.6802 216.369 41.6415 216.321 41.6152L216.224 41.7371C216.315 41.7884 216.326 41.8434 216.325 41.8801C216.323 41.9622 216.315 42.044 216.301 42.1248L216.454 42.1377C216.468 42.0534 216.477 41.9683 216.48 41.8828Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3 42.1248C216.28 42.2515 216.243 42.3749 216.19 42.4915L216.304 42.5951C216.382 42.4528 216.433 42.2975 216.454 42.1368L216.3 42.1248Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.123 42.5667L216.168 42.7143C216.228 42.6897 216.278 42.6446 216.308 42.5868L216.19 42.4888C216.167 42.5355 216.143 42.5667 216.123 42.5667Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.08 42.5731C216.048 42.5725 216.017 42.5653 215.988 42.552L215.92 42.6904C215.97 42.7144 216.025 42.7272 216.081 42.728C216.112 42.728 216.143 42.7231 216.172 42.7133L216.122 42.5685C216.108 42.5718 216.094 42.5734 216.08 42.5731Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.756 42.3513C215.704 42.2984 215.642 42.2565 215.574 42.2282C215.506 42.1998 215.432 42.1856 215.358 42.1863V42.3421C215.46 42.341 215.559 42.3794 215.633 42.4493C215.71 42.5512 215.808 42.6346 215.921 42.6932L215.983 42.552C215.894 42.5027 215.816 42.4342 215.756 42.3513Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.981 42.189L214.953 42.3448C215.09 42.3365 215.227 42.3365 215.364 42.3448L215.358 42.189C215.233 42.182 215.107 42.182 214.981 42.189Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.877 42.1918C214.86 42.1927 214.843 42.1927 214.826 42.1918L214.806 42.3458H214.877H214.959L214.981 42.1899L214.877 42.1918Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.759 42.1487L214.661 42.2678C214.703 42.3069 214.756 42.3333 214.812 42.3439L214.826 42.1899C214.801 42.1802 214.778 42.1662 214.759 42.1487Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.7 42.0845C214.708 42.0517 214.721 42.0206 214.74 41.9928L214.597 41.9277C214.563 41.9828 214.545 42.0463 214.545 42.1111C214.567 42.1791 214.611 42.2379 214.67 42.2779L214.761 42.1542C214.738 42.134 214.717 42.1105 214.7 42.0845Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.184 41.3283C212.145 41.3721 212.119 41.4257 212.109 41.4832L212.26 41.5143C212.264 41.4861 212.276 41.4596 212.294 41.4373C212.426 41.3703 212.574 41.3383 212.722 41.3443C212.871 41.3504 213.015 41.3945 213.142 41.4722L213.196 41.3273C213.043 41.2356 212.868 41.1872 212.69 41.1874C212.511 41.1875 212.336 41.2362 212.184 41.3283Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19 41.3246L213.142 41.4722C213.175 41.489 213.206 41.5103 213.233 41.5354C213.253 41.5645 213.265 41.5983 213.269 41.6334C213.272 41.6686 213.266 41.7039 213.252 41.7362L213.402 41.771C213.424 41.7133 213.429 41.6509 213.419 41.5901C213.409 41.5294 213.382 41.4726 213.342 41.4254C213.298 41.3837 213.246 41.3496 213.19 41.3246Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.187 41.8581C212.996 41.9156 212.792 41.9156 212.6 41.8581L212.555 42.0047C212.792 42.0806 213.049 42.0709 213.28 41.9772C213.345 41.921 213.39 41.8446 213.407 41.76L213.255 41.7316C213.247 41.78 213.223 41.8244 213.187 41.8581Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.287 41.683L212.15 41.7582C212.263 41.8764 212.404 41.9638 212.56 42.0121L212.6 41.8627C212.485 41.8241 212.379 41.763 212.287 41.683Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.279 41.672C212.254 41.6235 212.247 41.5675 212.26 41.5143L212.11 41.4768C212.087 41.5694 212.099 41.6676 212.144 41.7518L212.154 41.7664L212.287 41.6858L212.279 41.672Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.467 38.0118C210.781 38.3159 210.154 38.7403 209.617 39.2648L209.739 39.3565C210.246 38.8709 210.826 38.4687 211.459 38.1648C211.939 38.3153 212.436 38.4076 212.938 38.4398L212.987 38.2877C212.47 38.2651 211.959 38.1722 211.467 38.0118Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.981 38.2959L212.938 38.4481C213.015 38.4375 213.092 38.4539 213.158 38.4944C213.224 38.5348 213.273 38.5969 213.298 38.6699L213.446 38.6268C213.417 38.5273 213.356 38.4403 213.271 38.3802C213.187 38.3201 213.085 38.2904 212.981 38.2959Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.298 38.6699C213.329 38.7837 213.329 38.9036 213.298 39.0173L213.446 39.065C213.487 38.9197 213.487 38.7658 213.446 38.6204L213.298 38.6699Z",
    fill: "#DC8730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3 39.0173C213.29 39.0669 213.27 39.1141 213.243 39.1567C213.201 39.2048 213.148 39.2419 213.088 39.2648C213.029 39.2876 212.965 39.2955 212.902 39.2878C212.642 39.2878 212.273 39.1787 211.956 39.1787C211.841 39.1733 211.728 39.194 211.623 39.2392L211.692 39.3776C211.776 39.3448 211.866 39.3299 211.956 39.3336C212.256 39.3336 212.607 39.4418 212.902 39.4418C212.989 39.4499 213.076 39.4369 213.157 39.4036C213.238 39.3704 213.309 39.3181 213.365 39.2511C213.406 39.1929 213.434 39.1276 213.45 39.0586L213.3 39.0173Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.942 40.1173C210.927 40.1269 210.912 40.1354 210.896 40.143L211.014 40.2539L211.04 40.2365C211.12 40.1769 211.498 39.4848 211.698 39.3739L211.621 39.2392C211.383 39.3693 211.05 39.9945 210.942 40.1173Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.043 35.9905C210.022 35.984 210 35.9815 209.978 35.9832C209.819 35.9832 209.415 36.0363 209.077 36.0849L208.555 36.1647L208.687 36.2994L209.111 36.2362L209.978 36.1381H209.991L210.043 35.9905Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.038 35.9887L209.991 36.1381C210.121 36.2554 210.24 36.3849 210.346 36.5249L210.465 36.4259C210.347 36.2586 210.202 36.111 210.038 35.9887Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.593 36.8833C210.593 36.8962 210.602 36.975 210.602 36.9906L210.755 37.0373C210.758 36.9779 210.755 36.9184 210.746 36.8595C210.675 36.6989 210.578 36.5507 210.459 36.4204L210.346 36.5258C210.441 36.636 210.524 36.7558 210.593 36.8833Z",
    fill: "#B46027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.758 37.03L210.605 36.9897C210.605 37.0419 210.591 37.0612 210.527 37.1052C209.992 37.4588 209.483 37.8497 209.003 38.2748L208.405 38.8148V38.7909L208.283 39.0833C208.586 38.8877 208.863 38.6552 209.108 38.3913C209.584 37.9724 210.088 37.5862 210.616 37.2353C210.654 37.2147 210.687 37.1854 210.712 37.1497C210.737 37.114 210.753 37.073 210.758 37.03Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.375 37.525C208.284 38.0374 208.247 38.5578 208.264 39.0778C208.269 39.0791 208.273 39.0791 208.278 39.0778L208.403 38.8028L208.544 37.415L208.375 37.525Z",
    fill: "#BF6B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.692 36.2994L208.555 36.1647L208.371 37.5287L208.541 37.4159L208.692 36.2994Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.591 35.6C206.347 35.575 206.103 35.6342 205.897 35.7678L206.028 35.8594C206.205 35.7809 206.398 35.7467 206.591 35.7595C206.71 35.7577 206.829 35.7688 206.945 35.7925L207.012 35.6513C206.874 35.6167 206.733 35.5994 206.591 35.6Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.006 35.6422L206.945 35.7852C207.037 35.8139 207.119 35.8694 207.18 35.9447L207.336 35.8961C207.256 35.7782 207.14 35.6892 207.006 35.6422Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.175 35.9392L206.976 37.4104L207.121 37.4883L207.336 35.8961L207.175 35.9392Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.976 37.4104C206.932 37.7905 206.862 38.1671 206.768 38.5379L206.906 38.6085C207.007 38.2394 207.079 37.8631 207.122 37.4828L206.976 37.4104Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.643 38.625V38.7799C206.7 38.7771 206.755 38.7585 206.803 38.7262C206.851 38.6938 206.888 38.649 206.912 38.5966L206.772 38.5324C206.76 38.5577 206.742 38.5795 206.719 38.5957C206.697 38.612 206.67 38.6221 206.643 38.625Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.605 38.6149L206.394 38.4747L206.318 38.6094L206.515 38.7405C206.552 38.7673 206.596 38.7818 206.642 38.7818V38.625C206.629 38.6255 206.616 38.622 206.605 38.6149Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.357 37.4205C204.348 37.4156 204.338 37.41 204.329 37.404L204.215 37.5149C204.24 37.5327 204.266 37.5481 204.293 37.5608C204.988 37.8749 205.666 38.2262 206.324 38.6131L206.394 38.4747C205.734 38.0875 205.054 37.7356 204.357 37.4205Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17 37.0465C204.178 37.013 204.194 36.9817 204.215 36.9548L204.099 36.8549C204.063 36.9066 204.037 36.9649 204.024 37.0265C204.01 37.0882 204.009 37.1518 204.021 37.2138C204.032 37.2758 204.056 37.335 204.09 37.3877C204.125 37.4405 204.169 37.4859 204.222 37.5213L204.329 37.4058C204.269 37.3689 204.222 37.3149 204.194 37.2507C204.166 37.1866 204.157 37.1154 204.17 37.0465Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.034 36.7779C204.731 36.7779 204.514 36.7238 204.409 36.7229C204.349 36.7192 204.289 36.7296 204.235 36.7534C204.18 36.7771 204.131 36.8135 204.093 36.8595L204.215 36.9512C204.24 36.9247 204.27 36.904 204.303 36.8908C204.337 36.8777 204.373 36.8723 204.409 36.8751C204.616 36.9044 204.825 36.9231 205.034 36.931C205.198 36.9444 205.363 36.9127 205.51 36.8393L205.433 36.7046C205.308 36.764 205.171 36.7893 205.034 36.7779Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.426 36.7101L205.51 36.8403C205.764 36.5576 205.943 36.217 206.034 35.8484L205.897 35.765C205.815 36.1119 205.653 36.4352 205.426 36.7101Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.716 38.5333C203.55 38.4462 203.367 38.3935 203.179 38.3784C203.131 38.3763 203.083 38.3854 203.039 38.405L203.096 38.5508C203.121 38.5352 203.15 38.5287 203.179 38.5324C203.343 38.5472 203.502 38.5946 203.648 38.6718C203.831 38.7634 204.381 39.0778 204.756 39.3253L204.848 39.2034C204.482 38.9619 204.104 38.7383 203.716 38.5333Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.845 39.1961L204.753 39.3226C204.882 39.398 205.001 39.4905 205.105 39.5976C205.128 39.6414 205.14 39.6896 205.141 39.7387C205.143 39.7879 205.133 39.8367 205.114 39.8818L205.246 39.9643C205.281 39.8932 205.297 39.8151 205.295 39.7363C205.293 39.6575 205.272 39.5804 205.234 39.5114C205.12 39.3882 204.989 39.282 204.845 39.1961Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.116 39.8808C205.11 39.8964 205.051 40.0477 204.94 40.0468C204.677 40.0113 204.417 39.9549 204.163 39.8781C203.996 39.8417 203.824 39.8417 203.657 39.8781V40.0367C203.812 39.9971 203.973 39.9952 204.129 40.0312C204.397 40.1068 204.669 40.1647 204.945 40.2044C205.015 40.1988 205.082 40.1725 205.138 40.1288C205.193 40.0851 205.235 40.0259 205.257 39.9588L205.116 39.8808Z",
    fill: "#FDAC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.755 40.253L202.779 40.4125C203.054 40.2483 203.349 40.1207 203.657 40.033V39.8753C203.338 39.9526 203.034 40.0801 202.755 40.253Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.041 40.506L202.062 40.6591C202.312 40.6065 202.555 40.5227 202.784 40.4097L202.755 40.253C202.529 40.3671 202.289 40.4521 202.041 40.506Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.041 40.506C201.976 40.5236 201.908 40.5267 201.842 40.5152L201.786 40.6591C201.878 40.6843 201.976 40.6843 202.068 40.6591L202.041 40.506Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.695 39.8827L200.563 39.9679C200.799 40.2584 201.123 40.4651 201.485 40.5573L201.533 40.4088C201.204 40.3301 200.909 40.1452 200.695 39.8827Z",
    fill: "#FFB560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.681 39.5133L200.546 39.4326C200.504 39.5176 200.484 39.6116 200.488 39.7061C200.492 39.8007 200.519 39.8928 200.567 39.9743L200.695 39.8827C200.665 39.8263 200.647 39.7637 200.645 39.6997C200.642 39.6356 200.655 39.5718 200.681 39.5133Z",
    fill: "#F29B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.259 39.1686C201.977 39.1617 201.701 39.0848 201.456 38.9449C201.386 38.9039 201.306 38.8821 201.224 38.8817C201.071 38.904 200.927 38.9676 200.807 39.0656C200.687 39.1636 200.596 39.2924 200.544 39.4381L200.681 39.5133C200.72 39.3925 200.792 39.2846 200.887 39.2008C200.983 39.117 201.099 39.0603 201.224 39.0366C201.279 39.0367 201.333 39.0516 201.38 39.0797C201.648 39.2324 201.95 39.3159 202.259 39.3226C202.386 39.329 202.513 39.3008 202.626 39.241L202.552 39.1044C202.463 39.1547 202.361 39.177 202.259 39.1686Z",
    fill: "#7E3717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54 39.109L202.621 39.241C202.823 39.1209 203.006 38.6278 203.096 38.548L203.045 38.3986C202.875 38.46 202.752 38.9568 202.54 39.109Z",
    fill: "#9F5024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07 48.8559C195.874 48.8588 195.686 48.9346 195.543 49.0686C195.41 49.1912 195.318 49.351 195.278 49.527C195.238 49.703 195.252 49.887 195.318 50.0549L195.462 50.5343C195.496 50.6233 195.502 50.7202 195.481 50.8129C195.459 50.9055 195.411 50.9898 195.342 51.055C195.276 51.1187 195.189 51.1551 195.097 51.1568C195.027 51.1515 194.958 51.1317 194.896 51.0985C194.833 51.0654 194.779 51.0197 194.735 50.9643C194.641 50.8567 194.582 50.7231 194.566 50.5811C194.549 50.4392 194.576 50.2957 194.643 50.1695L194.167 49.9917C194.067 50.2042 194.033 50.4421 194.072 50.6739C194.11 50.9057 194.217 51.1204 194.38 51.2897C194.477 51.4102 194.599 51.5088 194.737 51.5788C194.875 51.6488 195.027 51.6887 195.181 51.6958C195.395 51.6941 195.6 51.6127 195.756 51.4675C195.885 51.3532 195.98 51.2047 196.028 51.0392C196.077 50.8736 196.078 50.6977 196.031 50.5316L195.841 49.9083C195.81 49.8327 195.801 49.7494 195.818 49.6691C195.834 49.5887 195.874 49.5152 195.933 49.4582C195.988 49.4047 196.062 49.3739 196.138 49.372C196.187 49.3743 196.234 49.3868 196.278 49.4087C196.321 49.4307 196.359 49.4616 196.39 49.4994C196.446 49.5653 196.481 49.647 196.49 49.7335C196.498 49.82 196.479 49.907 196.436 49.9825L196.907 50.1723C196.962 50.0312 196.983 49.8791 196.968 49.7283C196.954 49.5775 196.904 49.4322 196.824 49.3041C196.743 49.176 196.633 49.0686 196.503 48.9906C196.373 48.9126 196.227 48.8662 196.076 48.855L196.07 48.8559ZM198.13 50.5967L196.199 53.002L196.657 53.3687L198.59 50.9624L198.315 50.7452L198.131 50.5958L198.13 50.5967ZM199.451 51.6307L197.993 54.3504L198.443 54.5924L199.469 52.6812L199.57 55.1965L200.052 55.455L201.51 52.7353L201.067 52.4978L200.038 54.4173L199.933 51.8892L199.451 51.6307ZM203.323 53.3348C202.984 53.3431 202.658 53.4714 202.405 53.6969C202.151 53.9225 201.985 54.2307 201.937 54.5668C201.865 54.7541 201.834 54.9548 201.846 55.1552C201.858 55.3556 201.912 55.5512 202.006 55.7288C202.099 55.9064 202.23 56.062 202.388 56.185C202.547 56.3081 202.73 56.3958 202.925 56.4423C203.045 56.4733 203.168 56.4896 203.292 56.4908C203.477 56.4932 203.659 56.4503 203.823 56.366C203.988 56.2816 204.129 56.1583 204.234 56.0068L203.824 55.6704C203.753 55.7622 203.663 55.8374 203.56 55.8906C203.457 55.9438 203.344 55.9738 203.228 55.9784C203.166 55.9777 203.104 55.9694 203.045 55.9537C202.622 55.8464 202.345 55.4303 202.528 54.7125C202.679 54.1213 203.011 53.8453 203.383 53.8453C203.448 53.8457 203.512 53.8537 203.575 53.8692C203.696 53.8969 203.807 53.9571 203.897 54.0431C203.986 54.1292 204.051 54.2379 204.083 54.3578L204.614 54.2193C204.553 54.01 204.436 53.8213 204.275 53.6739C204.115 53.5265 203.917 53.426 203.703 53.3833C203.579 53.3514 203.451 53.3351 203.323 53.3348ZM205.654 53.7803L205.563 56.8639L207.554 56.9226L207.568 56.4386L206.163 56.3964L206.191 55.4798L207.213 55.51L207.227 55.0251L206.205 54.9948L206.226 54.2863L207.583 54.3257L207.598 53.8417L205.654 53.7839V53.7803ZM211.143 53.1918L210.858 53.2688L210.061 54.0177L210.346 54.3972L210.774 54.0718L211.382 56.3231L211.947 56.1709L211.143 53.1918ZM213.233 52.4053C213.07 52.407 212.909 52.4446 212.761 52.5153C212.65 52.5532 212.548 52.6133 212.46 52.692C212.373 52.7707 212.303 52.8663 212.253 52.973C212.204 53.0798 212.177 53.1954 212.174 53.3129C212.171 53.4304 212.192 53.5473 212.235 53.6565C212.296 53.7856 212.394 53.8941 212.515 53.9689C212.637 54.0438 212.778 54.0817 212.921 54.0782C212.792 54.1926 212.703 54.3459 212.669 54.5149C212.635 54.684 212.657 54.8596 212.732 55.015C212.804 55.1673 212.919 55.2951 213.063 55.3826C213.207 55.4701 213.374 55.5134 213.542 55.5073C213.73 55.5044 213.916 55.4609 214.086 55.3798C214.21 55.3388 214.325 55.2729 214.424 55.186C214.522 55.0992 214.602 54.9932 214.658 54.8746C214.714 54.756 214.745 54.6272 214.749 54.4961C214.754 54.365 214.732 54.2344 214.684 54.1121C214.622 53.9716 214.52 53.8524 214.391 53.7689C214.262 53.6854 214.111 53.6412 213.958 53.6418C213.921 53.642 213.885 53.6445 213.848 53.6492C213.944 53.5431 214.007 53.4113 214.029 53.2701C214.05 53.129 214.03 52.9845 213.971 52.8544C213.905 52.7162 213.8 52.6001 213.669 52.5204C213.538 52.4406 213.387 52.4007 213.233 52.4053ZM213.079 53.706C213.008 53.705 212.938 53.683 212.879 53.6428C212.819 53.6025 212.773 53.5458 212.746 53.4796C212.721 53.4307 212.707 53.3772 212.704 53.3225C212.702 53.2678 212.711 53.2132 212.731 53.1622C212.751 53.1112 212.781 53.0651 212.82 53.0267C212.859 52.9884 212.906 52.9587 212.957 52.9397C213.019 52.9092 213.087 52.8929 213.156 52.892C213.231 52.8929 213.304 52.9156 213.366 52.9575C213.428 52.9994 213.477 53.0585 213.506 53.1276C213.53 53.1759 213.544 53.229 213.546 53.2831C213.548 53.3373 213.539 53.3913 213.518 53.4414C213.497 53.4915 213.466 53.5366 213.427 53.5736C213.387 53.6105 213.34 53.6385 213.288 53.6556C213.223 53.6875 213.152 53.7047 213.079 53.706ZM213.608 55.0049C213.521 55.0063 213.435 54.9816 213.361 54.9339C213.288 54.8863 213.23 54.8178 213.196 54.7373C213.167 54.6749 213.151 54.6073 213.15 54.5386C213.149 54.47 213.162 54.4018 213.188 54.3384C213.215 54.2751 213.254 54.2179 213.304 54.1706C213.353 54.1232 213.413 54.0868 213.477 54.0635C213.558 54.0249 213.647 54.0043 213.737 54.003C213.829 54.0025 213.919 54.029 213.997 54.0794C214.074 54.1297 214.135 54.2016 214.172 54.2863C214.2 54.3477 214.215 54.4144 214.215 54.482C214.215 54.5495 214.201 54.6163 214.174 54.678C214.146 54.7398 214.106 54.795 214.056 54.8401C214.006 54.8853 213.947 54.9192 213.882 54.9398C213.796 54.9811 213.703 55.0033 213.607 55.0049H213.608ZM215.675 50.9798C215.429 50.9862 215.191 51.0695 214.994 51.2182C214.881 51.2905 214.784 51.3858 214.71 51.4979C214.635 51.61 214.585 51.7364 214.563 51.869C214.541 52.0016 214.546 52.1374 214.58 52.2677C214.613 52.3979 214.673 52.5198 214.757 52.6253L215.201 52.3063C215.163 52.2589 215.136 52.2047 215.12 52.1467C215.103 52.0887 215.099 52.028 215.106 51.9682C215.113 51.9084 215.132 51.8506 215.161 51.7982C215.191 51.7457 215.231 51.6995 215.278 51.6623C215.325 51.6251 215.38 51.5976 215.438 51.5814C215.496 51.5651 215.556 51.5605 215.616 51.5677C215.676 51.5749 215.734 51.5938 215.786 51.6233C215.839 51.6528 215.885 51.6924 215.922 51.7398C216.047 51.9658 216.08 52.2316 216.014 52.4813L215.83 54.1313L215.984 54.3458L217.677 53.1294L217.394 52.7362L216.435 53.4255L216.573 52.2953C216.639 51.9719 216.575 51.6356 216.394 51.3593C216.314 51.2418 216.206 51.1457 216.08 51.0795C215.954 51.0134 215.814 50.9791 215.672 50.9798H215.675ZM217.978 48.9604C217.817 48.96 217.657 48.9934 217.51 49.0584C217.362 49.1235 217.23 49.2188 217.122 49.3381C216.683 49.8148 216.642 50.6049 217.43 51.3318C217.735 51.6464 218.147 51.8338 218.585 51.8562C218.746 51.8565 218.906 51.823 219.054 51.7578C219.201 51.6926 219.333 51.5971 219.442 51.4776C219.881 51.0018 219.92 50.2108 219.134 49.4848C218.829 49.17 218.416 48.9826 217.978 48.9604ZM218.68 51.3053C218.359 51.2723 218.061 51.1226 217.842 50.8845C217.302 50.3849 217.249 49.9413 217.491 49.6791C217.541 49.6247 217.602 49.5816 217.669 49.5525C217.737 49.5234 217.81 49.5091 217.884 49.5104C218.205 49.5434 218.503 49.6935 218.721 49.9321C219.262 50.4308 219.315 50.8744 219.073 51.1375C219.023 51.1917 218.962 51.2347 218.894 51.2636C218.827 51.2925 218.754 51.3067 218.68 51.3053Z",
    fill: "#B43C19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7087 34.9079C32.7087 38.9413 35.4019 40.4473 39.4471 41.4603C43.2971 42.3769 44.0882 43.5805 44.0882 45.0976C44.0882 46.7788 42.5812 47.953 40.4215 47.953C38.0068 47.92 35.701 46.9432 33.9975 45.2314L31.9158 47.7981C34.195 49.9406 37.2063 51.1318 40.3344 51.1283C44.6519 51.1283 47.5523 48.5617 47.5523 44.7346C47.5523 41.3851 45.5466 39.3858 41.0439 38.251C36.9666 37.2427 36.1691 36.1427 36.1691 34.577C36.1691 33.2148 37.3287 31.8371 39.5443 31.8371C41.572 31.9133 43.5149 32.671 45.0589 33.9876L46.9161 31.2733C44.8754 29.5487 42.2791 28.6216 39.6075 28.6636C35.6099 28.6636 32.7087 31.2917 32.7087 34.9079ZM59.0729 34.9473L55.6226 46.0766L52.4977 35.0069H49.0098L53.9515 50.9468H57.0095L60.5167 39.9203L63.9927 50.9468H67.0516L72.0502 35.0069H68.6484L65.4667 46.0738L61.9834 34.9473H59.0729ZM73.7167 42.9168V42.9773C73.7167 47.7339 77.0094 51.187 81.5459 51.187C83.5881 51.2517 85.5991 50.6746 87.2962 49.537L86.3612 46.7549C84.9732 47.7393 83.3006 48.241 81.6 48.1831C80.4845 48.2359 79.3924 47.8515 78.5558 47.1117C77.7192 46.3718 77.2042 45.3349 77.1203 44.2213L77.1102 44.1562H88.4173V44.1342L88.4695 43.1882C88.4695 38.9504 86.2099 34.676 81.1637 34.676C76.9177 34.676 73.7167 38.218 73.7167 42.9168ZM77.0955 41.7939C77.4283 39.2135 79.0159 37.5479 81.1389 37.5479C83.3197 37.5479 84.8368 39.175 85.0962 41.7948L85.1017 41.8581H77.0845L77.0955 41.7939ZM103.541 28.6636V36.3572L103.45 36.2838C102.136 35.1886 100.464 34.6162 98.7545 34.676C95.24 34.676 91.6815 37.4957 91.6815 42.8866V42.9453C91.6815 48.3362 95.4325 51.1577 99.1368 51.1577C101.754 51.0991 104.365 50.8593 106.95 50.4399V28.6636H103.541ZM95.1163 42.9453V42.8866C95.1163 39.8983 97.0019 37.7285 99.5988 37.7285C102.006 37.7285 103.601 39.3363 103.601 39.9881V47.8311L103.554 47.8403C102.246 48.0402 100.922 48.1285 99.5988 48.1043C97.0431 48.1043 95.1163 45.8868 95.1163 42.9453ZM111.483 28.6636V50.4399C114.068 50.8593 116.678 51.0991 119.296 51.1577C123.001 51.1577 126.752 48.3362 126.752 42.9453V42.8866C126.752 37.4957 123.193 34.676 119.678 34.676C117.969 34.6164 116.297 35.1888 114.983 36.2838L114.892 36.3572V28.6636H111.483ZM114.875 47.8403L114.829 47.8311V39.9881C114.829 39.3363 116.423 37.7285 118.83 37.7285C121.426 37.7285 123.312 39.8983 123.312 42.8866V42.9453C123.312 45.8868 121.387 48.1043 118.83 48.1043C117.509 48.1281 116.188 48.0398 114.882 47.8403H114.875ZM130.943 36.0666L131.869 38.8872C133.234 38.2483 134.721 37.9151 136.228 37.9109C138.703 37.9109 140.069 39.142 140.069 41.3778V41.7591L139.993 41.7334C138.631 41.2703 137.199 41.047 135.761 41.0734C131.897 41.0734 129.589 43.003 129.589 46.237V46.2975C129.589 49.636 132.396 51.1558 135.004 51.1558C137.821 51.1092 140.632 50.8691 143.416 50.4372V41.4355C143.416 37.0722 141.102 34.7649 136.725 34.7649C134.722 34.7375 132.741 35.1835 130.943 36.0666ZM132.969 46.1151V46.0546C132.969 44.4688 134.307 43.5228 136.544 43.5228C137.754 43.5188 138.955 43.7363 140.087 44.1644L140.123 44.1782V48.2308L140.076 48.239C138.726 48.452 137.359 48.5498 135.992 48.5314C134.186 48.525 132.969 47.5579 132.969 46.1151ZM147.721 35.3928V50.8258H151.128V37.9925L151.175 37.9843C152.325 37.8112 153.487 37.7275 154.65 37.734C156.745 37.734 157.995 39.2658 157.995 41.8315V50.8258H161.402V40.7425C161.402 36.9988 159.328 34.6742 155.988 34.6742C153.219 34.7146 150.456 34.9548 147.721 35.3928ZM165.767 28.6636V50.8258H169.173V46.3039L171.39 43.9114L176.041 50.8258H179.978L173.697 41.4309L179.747 35.0069H175.622L169.166 42.1569V28.6636H165.767Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.606 30.0358) scale(30.1748 30.1748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2690_4771",
    x1: 218.922,
    y1: 22.4275,
    x2: 195.141,
    y2: 57.4799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#FFE6A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FCC677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#F5871E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F5871E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#E1690F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#CC5C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#9C3D0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#7E2A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73230A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2690_4771",
    x1: 196.034,
    y1: 56.2855,
    x2: 217.882,
    y2: 23.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#FFE6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#FCC877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F5871E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#F5871E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#E1690F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#DB650F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#AE490D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#8E340B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#7A280A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#73230A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.373 26.0364) scale(33.8754 33.8754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC85A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#F59619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#E56B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#DC5014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#BA3F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#B43C19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.311 26.5388) scale(32.7287 32.7287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.253 26.5103) scale(32.8286 32.8286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.235 26.4728) scale(32.7791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.344 26.4847) scale(32.7278 32.7277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.063 25.0061) scale(36.2631 36.2624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.97 26.1134) scale(33.4733 33.473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.714 25.3819) scale(34.7994 34.7994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.042 26.58) scale(32.9111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.673 26.0318) scale(34.2421 34.2421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.782 26.2977) scale(33.451 33.451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.761 26.5323) scale(34.4056 34.4052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.108 26.3426) scale(33.2733 33.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.191 26.3912) scale(33.7222 33.7223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.13 26.6093) scale(33.3494 33.3493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.288 26.6524) scale(34.1394 34.1394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.129 26.7019) scale(33.2547 33.2549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.264 26.6048) scale(33.3794 33.3795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.304 26.7881) scale(34.011 34.0111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.383 26.7725) scale(33.1853 33.1852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.479 26.4343) scale(33.703 33.7031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.115 26.4948) scale(33.1282 33.1283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.466 26.6213) scale(33.5125 33.5124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.678 26.1748) scale(33.8451 33.8452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.493 26.7184) scale(33.044 33.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.927 26.2931) scale(33.8496 33.8497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.534 26.338) scale(33.2089 33.209)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.063 26.4168) scale(34.4104 34.4108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.488 26.4132) scale(33.5343 33.5344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.834 25.722) scale(33.8864 33.8864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.775 26.1409) scale(33.4187 33.4189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.737 26.1464) scale(33.6178 33.6178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.711 25.8788) scale(33.7899 33.7902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.095 25.5185) scale(34.6699 34.6702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.785 25.6468) scale(34.1291 34.1294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.986 25.4928) scale(34.4914 34.4914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.05 25.9319) scale(33.8663 33.8663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.923 25.8815) scale(33.6682 33.6683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2690_4771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.102 24.7357) scale(35.752 35.7519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FFD05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFBE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF9B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#F7780F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3640F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65F19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2690_4771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 44,
    fill: "white",
    transform: "translate(31 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSwed);
export default __webpack_public_path__ + "static/media/bank-swed.c3ad78149cfb3c537ea9ecc7ddee0fc3.svg";
export { ForwardRef as ReactComponent };